(() => {
  'use strict';

  // Simple cleanup: Only fix body if stuck, NEVER remove modals
  try {
    // Only fix body if it's stuck without an active modal
    const hasActiveModal = document.getElementById('pc-individual-modal')?.classList.contains('active');
    if (!hasActiveModal && document.body.classList.contains('pc-modal-open')) {
      document.body.style.overflow = '';
      document.body.style.pointerEvents = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.classList.remove('pc-modal-open', 'cart-sidebar-show', 'overflow-hidden');
    }
  } catch (e) {
    // Silent fail
  }
  
  // Make emergency function available globally BEFORE anything else loads
  window.__sbEmergencyFix = function() {
    document.getElementById('sb-review-modal')?.remove();
    // Hide modal but KEEP IT IN DOM (don't remove!)
    const modal = document.getElementById('pc-individual-modal');
    if (modal) {
      modal.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; z-index: -1 !important; position: fixed !important; top: -9999px !important; left: -9999px !important;';
    }
    document.body.style.overflow = '';
    document.body.style.pointerEvents = '';
    document.body.style.position = '';
    document.body.classList.remove('pc-modal-open', 'cart-sidebar-show', 'overflow-hidden');
    Array.from(document.querySelectorAll('[style*="z-index: 10000"]')).forEach(el => el.style.display = 'none');
    alert('Page unblocked! If still blocked, refresh the page.');
  };

  const el = document.getElementById('subscription-quiz-builder');
  if (!el) return;

  const SIZE_INFO = {
    '3ml': { label: '3 ml', note: 'Sample' },
    '10ml': { label: '10 ml', note: 'Atomizer', badge: 'Best Seller' },
    '50ml': { label: '50 ml', note: 'Retail' },
    '100ml': { label: '100 ml', note: 'Retail', badge: 'Best Value' }
  };

  const normalizePlanId = (value) => {
    if (value === null || value === undefined) return '';
    const str = String(value).trim();
    return /^\d+$/.test(str) ? str : '';
  };

  const state = {
    planCount: Number(el.dataset.defaultPlanCount || '3'),
    refreshMode: el.dataset.defaultRefreshMode || 'same',
    monthlyPlanId: normalizePlanId(el.dataset.monthlyPlanId || ''),
    preferredSize: '10ml',
    recommendations: [],
    selections: new Map(),
    _boxByHandle: {}
  };
  const productCache = new Map();
  const pendingBrowsePersonalizations = {};
  const customizerBridge = {
    ensurePatched() {
      const pc = window.PerfumeCustomizer;
      if (!pc || !pc.Individual) return false;
      if (!pc.__builderPatched) {
        const originalAddToCart = pc.Individual.addToCart.bind(pc.Individual);
        const originalClose = pc.Individual.close.bind(pc.Individual);
        pc.Individual.addToCart = async function(...args) {
          // Check if in builder mode
          if (!pc.__builderCallback) {
            // Not in builder mode, use original addToCart
            return originalAddToCart(...args);
          }
          
          // Check if already processing to prevent double-click
          if (pc.__builderProcessing) {
            console.warn('⚠️ Builder mode: Already processing, ignoring duplicate click');
            return Promise.resolve();
          }
          
          // Mark as processing
          pc.__builderProcessing = true;
          
            const cb = pc.__builderCallback;
          const individual = pc.Individual; // Store reference to ensure correct context
          
          // Clear callback immediately to prevent double-click
            pc.__builderCallback = null;
          
          // Disable button to prevent double-click
          const addToCartBtn = document.getElementById('pc-add-to-cart-btn');
          if (addToCartBtn) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = 'Saving...';
          }
          
          // NEW APPROACH: Capture images FIRST while modal is visible, THEN close modal
          // This prevents white page because html2canvas needs the modal to be visible
          console.log('🚪 NEW APPROACH: Capturing images first, then closing modal...');
          
          // STEP 1: Preserve all customization data
          const preservedCustomization = JSON.parse(JSON.stringify(individual.customization || {}));
          const preservedProduct = individual.product;
          const preservedVariantId = individual.variantId;
            
            // Generate preview images BEFORE closing modal (html2canvas needs visible elements)
            let loadingMsg = null;
            let previewImageUrl = '';
            let printAreaImageUrl = '';
            let callbackCalled = false;
            
            // Simple and reliable close function
            const closeModalAfterCapture = () => {
              try {
                // Use native close method first
                if (window.PerfumeCustomizer?.Individual?.close) {
                  window.PerfumeCustomizer.Individual.close();
                }
                
                // Hide modal (keep in DOM)
                const modal = document.getElementById('pc-individual-modal');
                if (modal) {
                  modal.classList.remove('active');
                  modal.removeAttribute('style'); // Clear any inline styles
                }
                
                // Clear body styles - CRITICAL for white page fix
                document.body.classList.remove('pc-modal-open', 'overflow-hidden', 'cart-sidebar-show');
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.pointerEvents = '';
                
                // Clear html element
                if (document.documentElement) {
                  document.documentElement.style.overflow = '';
                  document.documentElement.style.position = '';
                }
                
                // Remove loading overlays only
                document.querySelectorAll('.pc-loading-overlay, [id*="loading"], [id*="saving"]').forEach(el => {
                  if (el && el.parentNode && el.id !== 'pc-individual-modal') {
                    el.remove();
                  }
                });
                
                // Restore scroll position
                if (window.PerfumeCustomizer?.Individual?.savedScrollPosition !== undefined) {
                  const savedScroll = window.PerfumeCustomizer.Individual.savedScrollPosition;
                  requestAnimationFrame(() => {
                    window.scrollTo({ top: savedScroll, left: 0, behavior: 'instant' });
                    window.PerfumeCustomizer.Individual.savedScrollPosition = undefined;
                  });
                }
              } catch (e) {
                console.error('Error closing modal:', e);
                // Emergency fallback
                const modal = document.getElementById('pc-individual-modal');
                if (modal) {
                  modal.classList.remove('active');
                  modal.removeAttribute('style');
                }
                document.body.classList.remove('pc-modal-open', 'overflow-hidden');
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.top = '';
              }
            };
            
            // Simple cleanup function (backup, not currently used)
            const forceCleanup = () => {
              try {
                // Remove loading overlays
                document.querySelectorAll('.pc-loading-overlay, [id*="loading"], [id*="saving"]').forEach(el => {
                  if (el && el.parentNode && el.id !== 'pc-individual-modal') {
                    el.remove();
                  }
                });
                
                // Hide modal (keep in DOM)
                const modal = document.getElementById('pc-individual-modal');
                if (modal) {
                  modal.classList.remove('active');
                  modal.removeAttribute('style');
                }
                
                // Clear body styles
                document.body.classList.remove('pc-modal-open', 'overflow-hidden', 'cart-sidebar-show');
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.top = '';
                
                // Clear html styles
                if (document.documentElement) {
                  document.documentElement.style.overflow = '';
                  document.documentElement.style.position = '';
                }
                
                // Clear processing flag
                pc.__builderProcessing = false;
                
                // Re-enable button
                if (addToCartBtn) {
                  addToCartBtn.disabled = false;
                  addToCartBtn.textContent = 'Save personalization';
                }
              } catch (e) {
                console.error('Error in force cleanup:', e);
                // Emergency fallback
                document.body.classList.remove('pc-modal-open', 'overflow-hidden');
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.top = '';
              }
            };
            
            // NEW APPROACH: Close modal AFTER images are captured, then call callback
            const callCallback = (payload) => {
              if (callbackCalled) {
                console.warn('⚠️ Builder mode: Callback already called, skipping');
                // Still ensure modal is closed
                closeModalAfterCapture();
                return;
              }
              callbackCalled = true;
              
              // STEP 1: Close modal NOW (after images are captured)
              closeModalAfterCapture();
              
              // STEP 2: Reset builder modal UI
              try {
            resetBuilderModalUI();
              } catch (e) {
                console.error('❌ Error resetting builder modal UI:', e);
              }
              
              // STEP 3: Wait a moment for DOM to settle, then call callback
              setTimeout(() => {
                try {
                  // Final verification - ensure modal is hidden and body is unblocked
                  const modalCheck = document.getElementById('pc-individual-modal');
                  if (modalCheck && modalCheck.classList.contains('active')) {
                    modalCheck.classList.remove('active');
                    modalCheck.removeAttribute('style');
                  }
                  
                  // Ensure body is unblocked
                  if (document.body.classList.contains('pc-modal-open') || 
                      document.body.style.position === 'fixed') {
                    document.body.classList.remove('pc-modal-open', 'overflow-hidden');
                    document.body.style.overflow = '';
                    document.body.style.position = '';
                    document.body.style.top = '';
                  }
                  
                  // Call callback
                  if (typeof cb === 'function') {
                    console.log('🔄 Builder mode: Calling callback with payload...');
                    try {
                      cb(payload);
                      console.log('✅ Builder mode: Callback executed');
                    } catch (callbackError) {
                      console.error('❌ Error in callback execution:', callbackError);
                      // On error, ensure page is unblocked
                      const errorModal = document.getElementById('pc-individual-modal');
                      if (errorModal) {
                        errorModal.classList.remove('active');
                        errorModal.removeAttribute('style');
                      }
                      document.body.classList.remove('pc-modal-open', 'overflow-hidden');
                      document.body.style.overflow = '';
                      document.body.style.position = '';
                      document.body.style.top = '';
                    }
                  } else {
                    console.error('❌ Builder mode: Callback is not a function!');
                  }
                  
                  // Simple post-callback check
                  setTimeout(() => {
                    const postCheckModal = document.getElementById('pc-individual-modal');
                    if (postCheckModal && postCheckModal.classList.contains('active')) {
                      postCheckModal.classList.remove('active');
                      postCheckModal.removeAttribute('style');
                    }
                    if (document.body.classList.contains('pc-modal-open') || document.body.style.position === 'fixed') {
                      document.body.classList.remove('pc-modal-open', 'overflow-hidden');
                      document.body.style.overflow = '';
                      document.body.style.position = '';
                      document.body.style.top = '';
                    }
                  }, 100);
                } catch (e) {
                  console.error('Error in callback execution:', e);
                  // On error, ensure page is unblocked
                  const errorModal = document.getElementById('pc-individual-modal');
                  if (errorModal) {
                    errorModal.classList.remove('active');
                    errorModal.removeAttribute('style');
                  }
                  document.body.classList.remove('pc-modal-open', 'overflow-hidden');
                  document.body.style.overflow = '';
                  document.body.style.position = '';
                  document.body.style.top = '';
                }
              }, 100); // Short delay to ensure modal is closed
            };
            
            // Set a shorter timeout to ensure callback is always called quickly
            const timeoutId = setTimeout(() => {
              console.warn('⏱️ Builder mode: Image generation timeout (5s), proceeding with basic payload');
              
              // Clear timeout flag
              clearTimeout(timeoutId);
              
              // Use preserved data
              const payload = JSON.parse(JSON.stringify(preservedCustomization || individual.customization || {}));
              payload.previewImageUrl = previewImageUrl || '';
              payload.printAreaImageUrl = printAreaImageUrl || '';
              payload.previewImage = previewImageUrl || '';
              
              // Close modal on timeout
              closeModalAfterCapture();
              
              // Call callback
              callCallback(payload);
            }, 5000); // 5 second timeout - very short to avoid hanging
            
            try {
              const IMGBB_API_KEY = 'a19b9be142be2bfd58e700684dc4962e';
              
              // NO LOADING OVERLAY - modal is already closed, page is unblocked
              // Process images in background without blocking UI
              console.log('🔄 Builder mode: Starting image generation in background...');
              
              // Try to capture images, but don't wait too long
              // Check if html2canvas is available first
              if (typeof html2canvas === 'undefined') {
                console.warn('⚠️ html2canvas not loaded, skipping image generation');
                // Clear timeout since we're skipping image generation
                clearTimeout(timeoutId);
                
                // Build payload without images
                const payload = JSON.parse(JSON.stringify(individual.customization || {}));
                payload.previewImageUrl = '';
                payload.printAreaImageUrl = '';
                payload.previewImage = '';
                console.log('✅ Builder mode: Payload prepared (no images):', {
                  hasCustomization: !!payload.textContent || !!payload.iconFilename || !!payload.logoFilename
                });
                
                // Call callback which will handle all cleanup (including removing overlays)
                callCallback(payload);
            return;
          }
              
              // Capture images with aggressive timeouts
              try {
                // Use Promise.race with a timeout to ensure we never wait too long
                await Promise.race([
                  (async () => {
                    // Capture preview screenshot
                    try {
                      console.log('🔄 Builder mode: Capturing preview screenshot...');
                      const previewImage = await Promise.race([
                        individual.capturePreviewScreenshot(),
                        new Promise((_, reject) => setTimeout(() => reject(new Error('Preview timeout')), 3000))
                      ]);
                      console.log('✅ Preview screenshot captured');
                      
                      const previewFilename = individual.generateImageFilename().replace('.png', '-preview.png');
                      console.log('🔄 Builder mode: Uploading preview...');
                      previewImageUrl = await Promise.race([
                        individual.uploadToImgbb(previewImage, IMGBB_API_KEY, previewFilename),
                        new Promise((_, reject) => setTimeout(() => reject(new Error('Upload timeout')), 3000))
                      ]);
                      console.log('✅ Preview image uploaded:', previewImageUrl);
                    } catch (err) {
                      console.warn('Preview capture/upload failed:', err.message);
                    }
                    
                    // Capture print area PNG
                    try {
                      console.log('🔄 Builder mode: Capturing print area...');
                      const printAreaPNG = await Promise.race([
                        individual.capturePrintAreaPNG(),
                        new Promise((_, reject) => setTimeout(() => reject(new Error('Print area timeout')), 3000))
                      ]);
                      console.log('✅ Print area PNG captured');
                      
                      const printFilename = individual.generateImageFilename();
                      console.log('🔄 Builder mode: Uploading print area...');
                      printAreaImageUrl = await Promise.race([
                        individual.uploadToImgbb(printAreaPNG, IMGBB_API_KEY, printFilename),
                        new Promise((_, reject) => setTimeout(() => reject(new Error('Upload timeout')), 3000))
                      ]);
                      console.log('✅ Print area PNG uploaded:', printAreaImageUrl);
                    } catch (err) {
                      console.warn('Print area capture/upload failed:', err.message);
                    }
                  })(),
                  // Overall timeout - max 7 seconds for all image operations
                  new Promise(resolve => setTimeout(resolve, 7000))
                ]);
              } catch (err) {
                console.error('Image generation error:', err);
              }
              
              // Clear timeout since we completed
              clearTimeout(timeoutId);
              
              // Build payload with preview images (use preserved data)
              const payload = JSON.parse(JSON.stringify(preservedCustomization || individual.customization || {}));
              payload.previewImageUrl = previewImageUrl;
              payload.printAreaImageUrl = printAreaImageUrl; // PRIORITY: Use this for cart
              payload.printAreaPNG = printAreaImageUrl; // Alternative key
              payload.previewImage = previewImageUrl; // For backwards compatibility
              
              console.log('✅ Builder mode: Payload prepared:', {
                hasPreview: !!previewImageUrl,
                hasPrintArea: !!printAreaImageUrl,
                previewImageUrl: previewImageUrl?.substring(0, 50) || 'N/A',
                printAreaImageUrl: printAreaImageUrl?.substring(0, 50) || 'N/A',
                hasCustomization: !!payload.textContent || !!payload.iconFilename || !!payload.logoFilename
              });
              
              // Close modal AFTER images are captured, then call callback
              callCallback(payload);
            } catch (error) {
              console.error('❌ Error in builder mode:', error);
              clearTimeout(timeoutId);
              
              // Still call callback with basic payload - it will handle cleanup
              const payload = JSON.parse(JSON.stringify(individual.customization || {}));
              payload.previewImageUrl = previewImageUrl || '';
              payload.printAreaImageUrl = printAreaImageUrl || '';
              payload.previewImage = previewImageUrl || '';
              
              // Ensure callback is called even on error to prevent black page
              callCallback(payload);
            }
            
            return Promise.resolve();
        };
        pc.Individual.close = function(...args) {
          resetBuilderModalUI();
          pc.__builderCallback = null;
          return originalClose(...args);
        };
        pc.__builderPatched = true;
      }
      return true;
    },
    open(product, variantId, onSave) {
      try {
        console.log('🔧 Opening customizer...', { product: product?.title, variantId });
        
      const pc = window.PerfumeCustomizer;
        if (!pc) {
          console.error('❌ window.PerfumeCustomizer is not defined');
          alert('Customizer is not loaded. Please refresh the page.');
          return false;
        }
        
        if (!pc.Individual) {
          console.error('❌ window.PerfumeCustomizer.Individual is not defined');
          alert('Customizer is not initialized. Please refresh the page.');
          return false;
        }
        
        if (typeof pc.Individual.open !== 'function') {
          console.error('❌ pc.Individual.open is not a function');
          alert('Customizer open function is not available. Please refresh the page.');
          return false;
        }
        
        // Check if modal element exists
        let modalElement = document.getElementById('pc-individual-modal');
        if (!modalElement) {
          console.warn('⚠️ Modal element not found, checking if we need to load it...');
          // Modal might not be loaded yet - wait a bit and check again
          setTimeout(() => {
            modalElement = document.getElementById('pc-individual-modal');
            if (!modalElement) {
              console.error('❌ Modal element still not found after waiting');
              alert('Customizer modal is not loaded on this page. Please contact support.');
              return false;
            }
          }, 500);
        }
        
        if (!this.ensurePatched()) {
          console.error('❌ Failed to patch customizer');
          alert('Failed to initialize customizer. Please refresh the page.');
          return false;
        }
        
      pc.__builderCallback = onSave;
        
        // Save scroll position BEFORE opening modal to prevent jump
        const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        if (pc.Individual.savedScrollPosition !== undefined) {
          pc.Individual.savedScrollPosition = scrollY;
        }
        
        // Ensure page is not blocked before opening
        const blockingElements = document.querySelectorAll('[style*="z-index: 10000"]');
        blockingElements.forEach(el => {
          if (!el.id || (el.id !== 'pc-individual-modal' && !el.classList.contains('pc-individual-modal'))) {
            const rect = el.getBoundingClientRect();
            if (rect.width >= window.innerWidth * 0.9 && rect.height >= window.innerHeight * 0.9) {
              console.warn('⚠️ Removing blocking element before opening modal:', el);
              el.style.display = 'none';
            }
          }
        });
        
        // Prevent scroll jump by setting body top BEFORE adding position:fixed
        document.body.style.top = `-${scrollY}px`;
        
        console.log('🔧 Calling pc.Individual.open...');
        
        // Ensure modal exists and is properly reset before opening
        if (modalElement) {
          // Reset any styles we may have applied
          modalElement.removeAttribute('style');
          modalElement.classList.remove('active'); // Will be added by open()
        }
        
        // Open modal - this will add pc-modal-open class which sets position: fixed
        try {
      pc.Individual.open(product, variantId);
          console.log('✅ pc.Individual.open called successfully');
        } catch (openError) {
          console.error('❌ Error calling pc.Individual.open:', openError);
          alert('Failed to open customizer. Please try again.');
          return false;
        }
        
        // Double-check modal opened and body has correct top value
        requestAnimationFrame(() => {
          if (document.body.classList.contains('pc-modal-open')) {
            const currentTop = document.body.style.top;
            if (!currentTop || currentTop === '0px') {
              document.body.style.top = `-${scrollY}px`;
            }
          }
        });
        
        // Wait a bit for modal to initialize, then set builder UI
        setTimeout(() => {
          const modal = document.getElementById('pc-individual-modal');
          if (modal) {
            setBuilderModalUI();
            
            // Verify modal is actually open
            const isOpen = modal.classList.contains('active');
            if (!isOpen) {
              console.warn('⚠️ Modal failed to open automatically, attempting manual open');
              // Try to open it manually
              modal.classList.add('active');
              if (!document.body.classList.contains('pc-modal-open')) {
                document.body.classList.add('pc-modal-open');
                document.body.style.top = `-${scrollY}px`;
              }
              console.log('✅ Modal opened manually');
            } else {
              console.log('✅ Modal is open');
            }
          } else {
            console.error('❌ Modal element disappeared after opening');
          }
        }, 100);
        
      return true;
      } catch (error) {
        console.error('❌ Error opening customizer:', error);
        alert('An error occurred while opening the customizer. Please try again or refresh the page.');
        // Ensure page is unblocked on error
        document.body.style.overflow = '';
        document.body.style.pointerEvents = '';
        document.body.style.top = '';
        document.body.classList.remove('pc-modal-open', 'overflow-hidden');
        return false;
      }
    }
  };

  function setBuilderModalUI() {
    const modal = document.getElementById('pc-individual-modal');
    if (modal) {
      modal.setAttribute('data-builder-mode', 'true');
      const primaryBtn = modal.querySelector('.pc-btn-primary');
      if (primaryBtn) {
        if (!primaryBtn.dataset.originalLabel) {
          primaryBtn.dataset.originalLabel = primaryBtn.textContent;
        }
        primaryBtn.textContent = 'Save personalization';
      }
    }
  }

  function resetBuilderModalUI() {
    const modal = document.getElementById('pc-individual-modal');
    if (modal) {
      modal.removeAttribute('data-builder-mode');
      const primaryBtn = modal.querySelector('.pc-btn-primary');
      if (primaryBtn && primaryBtn.dataset.originalLabel) {
        primaryBtn.textContent = primaryBtn.dataset.originalLabel;
      }
    }
  }
  state.sizeOrder = Object.keys(SIZE_INFO);

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const grid = $('[data-recos-grid]', el);
  const empty = $('[data-recos-empty]', el);
  const summaryCount = $('[data-summary-count]', el);
  const summaryTotal = $('[data-summary-total]', el);
  const summaryGoal = $('[data-summary-goal]', el);
  const planGoalInline = $('[data-plan-goal-inline]', el);
  const selectionList = $('[data-selection-list]', el);
  const selectionEmpty = $('[data-selection-empty]', el);
  const submitBtn = $('[data-add-to-cart]', el);
  const planCountWrap = $('[data-plan-count]', el);
  const refreshWrap = $('[data-refresh-mode]', el);
  const submitHint = $('[data-submit-hint]', el);
  const sizePicker = $('[data-size-picker]', el);
  const progressBar = $('[data-progress-bar]', el);
  const progressText = $('[data-progress-text]', el);
  
  // Ensure submit button exists
  if (!submitBtn) {
    console.error('❌ Submit button not found! Looking for [data-add-to-cart]');
  }
  const modeButtons = $$('[data-mode-toggle]', el);
  const modePanels = $$('[data-mode-panel]', el);
  const hasQuizPanel = modePanels.some(panel => panel.dataset.modePanel === 'quiz');
  const categoryButtons = $$('[data-category-btn]', el);
  const categoryPanels = $$('[data-category-panel]', el);
  const browseCards = $$('[data-category-panel] .sb-card--browse', el);

  const moneyFormatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: Shopify?.currency?.active || 'USD'
  });

  const toMoney = (cents = 0) => moneyFormatter.format(Number(cents) / 100);
  const ESCAPE_MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  const escapeHtml = (str = '') => String(str).replace(/[&<>"']/g, (m) => ESCAPE_MAP[m] || m);
  function showHint(message = '', duration = 3200) {
    if (!submitHint) return;
    submitHint.textContent = message || '';
    if (message && duration > 0) {
      clearTimeout(showHint.timer);
      showHint.timer = setTimeout(() => {
        if (submitHint.textContent === message) submitHint.textContent = '';
      }, duration);
    }
  }

  function updateProgress(selectedCount = 0) {
    if (progressBar) {
      progressBar.style.width = '0%';
    }
    if (progressText) {
      progressText.textContent = `${selectedCount} selected`;
    }
  }

  function syncBrowseButtons() {
    $$('[data-browse-handle]', el).forEach(btn => {
      const handle = btn.dataset.browseHandle;
      const entry = state.selections.get(handle);
      const isSelected = !!entry?.selected;
      btn.classList.toggle('is-selected', isSelected);
      btn.textContent = isSelected ? 'Selected' : 'Select scent';
      btn.disabled = false; // No limit - allow unlimited selections
    });
  }

  function resetSelections() {
    console.log('🔄 Resetting all selections...');
    
    // Clear all selections (but keep personalizations for editing)
    state.selections.forEach((entry, handle) => {
      entry.selected = false;
      
      // Update card UI
      const card = document.querySelector(`[data-handle="${handle}"]`);
      if (card) {
        card.classList.remove('selected');
        const toggleBtn = card.querySelector('[data-toggle-select]');
        if (toggleBtn) {
          toggleBtn.textContent = 'Select';
        }
      }
      
      // Update browse button UI
      const browseBtn = document.querySelector(`[data-browse-handle="${handle}"]`);
      if (browseBtn) {
        browseBtn.classList.remove('is-selected');
        browseBtn.textContent = 'Select scent';
      }
      
      // Update personalize button text based on whether personalization exists
      const personalizeBtn = card?.querySelector('[data-browse-personalize]');
      if (personalizeBtn && entry.personalization) {
        personalizeBtn.textContent = 'Edit Customization';
      }
    });
    
    // Note: Personalizations are kept so users can edit them if they want to customize again
    // pendingBrowsePersonalizations are also kept so users can edit them
    
    // Update UI
    updateSummary();
    syncBrowseButtons();
    persistContext();
    
    console.log('✅ All selections reset (personalizations kept for editing)');
  }

  function setMode(mode) {
    modeButtons.forEach(btn => btn.classList.toggle('is-active', btn.dataset.modeToggle === mode));
    modePanels.forEach(panel => panel.classList.toggle('is-active', panel.dataset.modePanel === mode));
  }

  function initModeSwitch() {
    if (!modeButtons.length) return;
    const active = modeButtons.find(btn => btn.classList.contains('is-active'))?.dataset.modeToggle || modeButtons[0].dataset.modeToggle;
    setMode(active);
    modeButtons.forEach(btn => {
      btn.addEventListener('click', () => setMode(btn.dataset.modeToggle));
    });
  }

  function initCategoryNav() {
    if (!categoryButtons.length) return;
    const activate = (id) => {
      categoryButtons.forEach(btn => btn.classList.toggle('is-active', btn.dataset.categoryBtn === id));
      categoryPanels.forEach(panel => panel.classList.toggle('is-active', panel.dataset.categoryPanel === id));
    };
    const initial = categoryButtons.find(btn => btn.classList.contains('is-active'))?.dataset.categoryBtn || categoryButtons[0].dataset.categoryBtn;
    activate(initial);
    categoryButtons.forEach(btn => {
      btn.addEventListener('click', () => activate(btn.dataset.categoryBtn));
    });
  }

  function setBrowseCardSize(card, size) {
    if (!card || !size) return;
    card.dataset.selectedSize = size;
    const row = card.querySelector('[data-browse-size-row]');
    if (row) {
      $$('[data-browse-size]', row).forEach(btn => {
        btn.classList.toggle('active', btn.dataset.browseSize === size);
      });
    }
    const personalizeBtn = card.querySelector('[data-browse-personalize]');
    if (personalizeBtn) {
      const handle = card.dataset.handle;
      const linkedEntry = handle ? state.selections.get(handle) : null;
      const hasPending = pendingBrowsePersonalizations[handle];
      const hasActiveCustomization = linkedEntry && linkedEntry.personalization && linkedEntry.chosenSize === '10ml';
      const shouldShow = size === '10ml';
      personalizeBtn.textContent = hasPending ? 'Edit Customization' : 'Customize your Atomizer + ($4.99)';
      if (hasPending || hasActiveCustomization) {
        personalizeBtn.textContent = 'Edit Customization';
      }
      personalizeBtn.style.display = shouldShow ? '' : 'none';
    }
    updateBrowseCardPrice(card, size);
  }

  async function updateBrowseCardPrice(card, size) {
    const handle = card?.dataset?.handle;
    if (!handle) return;
    try {
      const product = await getProductData(handle);
      const variant = mapSizeToVariant(product, size);
      const priceEl = card.querySelector('[data-browse-price]');
      if (priceEl && variant) {
        priceEl.textContent = toMoney(variant.price);
      }
      
      // Update images with smooth transition
      const originalImageEl = card.querySelector('.sb-card-original-image');
      const variantImageEl = card.querySelector('.sb-card-variant-image');
      const originalImage = getOriginalImage(product);
      const variantImage = getVariantImage(variant, product);
      
      // Never show variant image - only show main product image
      const shouldShowVariantImage = false;
      
      // Update original image
      if (originalImageEl && originalImage) {
        // Only update if the image source is different
        if (originalImageEl.src !== originalImage) {
          // Preload image for faster transition
          const img = new Image();
          img.onload = () => {
            originalImageEl.style.opacity = '0';
            originalImageEl.style.transition = 'opacity 0.3s ease-in-out';
            setTimeout(() => {
              originalImageEl.src = originalImage;
              originalImageEl.style.opacity = '1';
            }, 50);
          };
          img.onerror = () => {
            // If image fails to load, still update but without transition
            originalImageEl.src = originalImage;
          };
          img.src = originalImage;
        }
      }
      
      // Update variant image
      if (variantImageEl) {
        if (shouldShowVariantImage && variantImage) {
          // Only update if the image source is different or it's hidden
          if (variantImageEl.src !== variantImage || variantImageEl.style.display === 'none') {
            // Preload image for faster transition
            const img = new Image();
            img.onload = () => {
              variantImageEl.style.display = 'block';
              variantImageEl.style.opacity = '0';
              variantImageEl.style.transition = 'opacity 0.3s ease-in-out';
              setTimeout(() => {
                variantImageEl.src = variantImage;
                variantImageEl.style.opacity = '1';
              }, 50);
            };
            img.onerror = () => {
              // If image fails to load, still update but without transition
              variantImageEl.style.display = 'block';
              variantImageEl.src = variantImage;
            };
            img.src = variantImage;
          }
        } else {
          variantImageEl.style.display = 'none';
        }
      }
    } catch (err) {
      console.warn('Unable to update price for', handle, err);
    }
  }

  async function handleBrowsePersonalize(button) {
    // Prevent multiple clicks
    if (button.disabled) return;
    button.disabled = true;
    
    const card = button.closest('.sb-card--browse');
    const handle = card?.dataset?.handle;
    const size = card?.dataset?.selectedSize || '10ml';
    if (size !== '10ml') {
      button.disabled = false;
      showHint('Customization is available for 10 ml atomizers only.');
      return;
    }
    if (!handle) {
      button.disabled = false;
      return;
    }
    try {
      // Ensure page is not blocked before opening modal
      document.body.style.overflow = '';
      document.body.style.pointerEvents = '';
      
      const product = await getProductData(handle);
      const variant = mapSizeToVariant(product, '10ml');
      if (!variant) {
        button.disabled = false;
        showHint('Unable to load 10 ml variant for customization.');
        return;
      }
      
      // Save current scroll position to prevent jump
      const currentScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      
      // Add small delay to ensure any blocking elements are cleared
      await new Promise(resolve => setTimeout(resolve, 100));
      
      const opened = customizerBridge.open(product, variant.id, (payload) => {
        button.disabled = false;
        if (payload) {
          pendingBrowsePersonalizations[handle] = payload;
          button.textContent = 'Edit Customization';
        } else {
          delete pendingBrowsePersonalizations[handle];
          button.textContent = 'Customize your Atomizer + ($4.99)';
        }
        const entry = state.selections.get(handle);
        if (entry) {
          if (entry.chosenSize === '10ml') {
            entry.personalization = payload || null;
            // Auto-select after customization
            if (payload) {
              entry.selected = true;
              // Update UI to show selected state
              const card = document.querySelector(`[data-handle="${handle}"]`);
              if (card) {
                card.classList.add('selected');
                const toggleBtn = card.querySelector('[data-toggle-select]');
                if (toggleBtn) {
                  toggleBtn.textContent = 'Selected';
                }
              }
              // Also update browse button if it exists
              const browseBtn = document.querySelector(`[data-browse-handle="${handle}"]`);
              if (browseBtn) {
                browseBtn.classList.add('is-selected');
                browseBtn.textContent = 'Selected';
              }
            }
            updateSummary();
            syncBrowseButtons();
            persistContext();
          } else if (!payload) {
            delete pendingBrowsePersonalizations[handle];
          }
        } else {
          // Entry doesn't exist yet - auto-select after customization
          if (payload) {
            console.log('🔄 Entry does not exist yet, will auto-select after customization:', handle);
            // Trigger selection automatically after customization
            // Use a longer delay to ensure modal is closed
            setTimeout(async () => {
              console.log('🔄 Auto-selecting item after customization:', handle);
              try {
                // AGGRESSIVE CHECK: Ensure page is unblocked before auto-selection
                const preCheckModal = document.getElementById('pc-individual-modal');
                if (preCheckModal && (preCheckModal.classList.contains('active') || window.getComputedStyle(preCheckModal).display !== 'none')) {
                  console.warn('⚠️ Modal still visible before auto-selection, force closing...');
                  preCheckModal.classList.remove('active');
                  preCheckModal.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; z-index: -1 !important;';
                }
                
                if (document.body.classList.contains('pc-modal-open') || document.body.style.position === 'fixed') {
                  console.warn('⚠️ Body still blocked before auto-selection, force fixing...');
                  document.body.style.cssText = '';
                  document.body.classList.remove('pc-modal-open', 'overflow-hidden');
                }
                
                // First, ensure we have the product data
                const product = await getProductData(handle);
                if (!product) {
                  console.error('❌ Could not load product:', handle);
                  // Still ensure page is unblocked on error
                  document.body.style.cssText = '';
                  document.body.classList.remove('pc-modal-open', 'overflow-hidden');
                  return;
                }
                
                // Check if entry exists now (might have been created)
                let entry = state.selections.get(handle);
                
                if (!entry) {
                  // Create the entry by rendering the card
                  entry = renderCard(product);
                  if (!entry) {
                    console.error('❌ Could not create entry for:', handle);
                    // Still ensure page is unblocked on error
                    document.body.style.cssText = '';
                    document.body.classList.remove('pc-modal-open', 'overflow-hidden');
                    return;
                  }
                }
                
                // Ensure it's set to 10ml and has the personalization
                entry.chosenSize = '10ml';
                entry.variant = mapSizeToVariant(entry.product, '10ml');
                entry.variantImage = getVariantImage(entry.variant, entry.product);
                entry.originalImage = getOriginalImage(entry.product);
                entry.personalization = payload; // Set the personalization
                // Auto-select after customization
                entry.selected = true;
                entry.manualOverride = false;
                
                // Update UI
                updateCardSizeUI(entry);
                
                // Update card to show selected state
                const card = document.querySelector(`[data-handle="${handle}"]`);
                if (card) {
                  card.classList.add('selected');
                  const toggleBtn = card.querySelector('[data-toggle-select]');
                  if (toggleBtn) {
                    toggleBtn.textContent = 'Selected';
                  }
                }
                
                // Also update browse button if it exists
                const browseBtn = document.querySelector(`[data-browse-handle="${handle}"]`);
                if (browseBtn) {
                  browseBtn.classList.add('is-selected');
                  browseBtn.textContent = 'Selected';
                }
                
                // Clear the pending personalization since we've applied it
                delete pendingBrowsePersonalizations[handle];
                
                // Update summary and persist
                updateSummary();
                syncBrowseButtons();
                persistContext();
                
                console.log('✅ Personalization saved:', {
                  handle: handle,
                  title: entry.product?.title,
                  hasPersonalization: !!entry.personalization
                });
                
                // CRITICAL: After auto-selection completes, check for white page again
                setTimeout(() => {
                  try {
                    // Check for any white overlays or blocking elements
                    const allElements = Array.from(document.querySelectorAll('*'));
                    const whiteOverlays = allElements.filter(el => {
                      try {
                        const style = window.getComputedStyle(el);
                        const bg = style.backgroundColor || style.background || '';
                        const isWhite = bg.includes('255, 255, 255') || 
                                       bg.includes('rgb(255, 255, 255)') || 
                                       bg.includes('rgba(255, 255, 255') ||
                                       bg.includes('#fff') ||
                                       bg.includes('#ffffff');
                        const isFixed = style.position === 'fixed' || style.position === 'absolute';
                        const highZIndex = style.zIndex && parseInt(style.zIndex) > 100;
                        const fullSize = (style.width === '100%' || style.width === '100vw' || parseInt(style.width) >= window.innerWidth) &&
                                        (style.height === '100%' || style.height === '100vh' || parseInt(style.height) >= window.innerHeight);
                        
                        return isWhite && isFixed && highZIndex && fullSize;
                      } catch (e) {
                        return false;
                      }
                    });
                    
                    if (whiteOverlays.length > 0) {
                      console.warn('⚠️ WHITE OVERLAY DETECTED after auto-selection! Removing...', whiteOverlays);
                      whiteOverlays.forEach(overlay => {
                        try {
                          overlay.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; z-index: -1 !important;';
                          if (overlay.parentNode) {
                            overlay.remove();
                          }
                        } catch (e) {
                          console.warn('Failed to remove white overlay:', e);
                        }
                      });
                    }
                    
                    // Final check for modal and body blocking
                    const finalModalCheck = document.getElementById('pc-individual-modal');
                    if (finalModalCheck && (finalModalCheck.classList.contains('active') || window.getComputedStyle(finalModalCheck).display !== 'none')) {
                      console.warn('⚠️ Modal reappeared after auto-selection, force closing...');
                      finalModalCheck.classList.remove('active');
                      finalModalCheck.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; z-index: -1 !important;';
                    }
                    
                    if (document.body.classList.contains('pc-modal-open') || 
                        document.body.style.position === 'fixed' ||
                        window.getComputedStyle(document.body).position === 'fixed') {
                      console.warn('⚠️ Body became blocked after auto-selection, force fixing...');
                      document.body.style.cssText = '';
                      document.body.classList.remove('pc-modal-open', 'overflow-hidden', 'cart-sidebar-show');
                      
                      if (document.documentElement) {
                        document.documentElement.style.overflow = '';
                        document.documentElement.style.position = '';
                      }
                      
                      console.log('✅ White page fixed after auto-selection');
                    }
                  } catch (e) {
                    console.error('Error in post-auto-selection check:', e);
                  }
                }, 100); // Check 100ms after auto-selection
              } catch (error) {
                console.error('❌ Error auto-selecting after customization:', error);
                // On error, ensure page is always unblocked
                try {
                  const errorModal = document.getElementById('pc-individual-modal');
                  if (errorModal) {
                    errorModal.classList.remove('active');
                    errorModal.style.cssText = 'display: none !important; visibility: hidden !important;';
                  }
                  document.body.style.cssText = '';
                  document.body.classList.remove('pc-modal-open', 'overflow-hidden');
                } catch (e) {}
              }
            }, 300);
          }
        }
      });
      if (!opened) {
        button.disabled = false;
        showHint('Personalization modal unavailable. Please customize from the product page after adding to cart.');
      }
    } catch (err) {
      button.disabled = false;
      console.error('Failed to open customizer', err);
      showHint('Unable to open customizer. Please try again.');
      // Ensure page is unblocked on error
      document.body.style.overflow = '';
      document.body.style.pointerEvents = '';
      document.body.classList.remove('pc-modal-open', 'overflow-hidden');
    }
  }

  function openEntryCustomizer(entry, button) {
    // Prevent multiple clicks
    if (button && button.disabled) return;
    if (button) button.disabled = true;
    
    if (!entry || !entry.product || !entry.variant?.id) {
      if (button) button.disabled = false;
      showHint('Select a 10 ml option first.');
      return;
    }
    
    try {
      // Ensure page is not blocked before opening modal
      document.body.style.overflow = '';
      document.body.style.pointerEvents = '';
      
    const opened = customizerBridge.open(entry.product, entry.variant.id, (payload) => {
        if (button) button.disabled = false;
      entry.personalization = payload || null;
      // Auto-select after customization
      if (payload) {
        entry.selected = true;
        // Update card UI to show selected state
        const card = document.querySelector(`[data-handle="${entry.product?.handle}"]`);
        if (card) {
          card.classList.add('selected');
          const toggleBtn = card.querySelector('[data-toggle-select]');
          if (toggleBtn) {
            toggleBtn.textContent = 'Selected';
          }
        }
        // Also update browse button if it exists
        const browseBtn = document.querySelector(`[data-browse-handle="${entry.product?.handle}"]`);
        if (browseBtn) {
          browseBtn.classList.add('is-selected');
          browseBtn.textContent = 'Selected';
        }
      }
      
      if (button) {
        button.textContent = entry.personalization ? 'Edit Customization' : 'Customize your Atomizer + ($4.99)';
      }
      updateSummary();
      syncBrowseButtons();
      persistContext();
    });
    if (!opened) {
        if (button) button.disabled = false;
      showHint('Personalization modal unavailable. Please customize from the product page after adding to cart.');
      }
    } catch (err) {
      if (button) button.disabled = false;
      console.error('Failed to open customizer', err);
      showHint('Unable to open customizer. Please try again.');
      // Ensure page is unblocked on error
      document.body.style.overflow = '';
      document.body.style.pointerEvents = '';
      document.body.classList.remove('pc-modal-open', 'overflow-hidden');
    }
  }

  async function initBrowseCards() {
    if (!browseCards.length) return;
    for (const card of browseCards) {
      const handle = card.dataset.handle;
      if (handle) {
        try {
          const product = await getProductData(handle);
          const variant = mapSizeToVariant(product, state.preferredSize);
          const originalImage = getOriginalImage(product);
          const variantImage = getVariantImage(variant, product);
          
          // Check if card already has the wrapper structure, if not, create it
          let mediaWrapper = card.querySelector('.sb-card-media-wrapper');
          const selectedSize = card.dataset.selectedSize || state.preferredSize;
          const shouldShowVariantImage = false; // Never show variant image
          
          if (!mediaWrapper) {
            const existingImg = card.querySelector('.sb-card-media');
            if (existingImg) {
              mediaWrapper = document.createElement('div');
              mediaWrapper.className = 'sb-card-media-wrapper';
              mediaWrapper.style.cssText = 'position: relative; width: 100%; padding-bottom: 100%; overflow: hidden;';
              
              const originalImg = document.createElement('img');
              originalImg.className = 'sb-card-media sb-card-original-image';
              originalImg.style.cssText = 'position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; transition: opacity 0.4s ease-in-out;';
              originalImg.src = originalImage;
              
              // Variant image removed - only show main product image
              
              mediaWrapper.appendChild(originalImg);
              existingImg.replaceWith(mediaWrapper);
            }
          } else {
            const originalImg = mediaWrapper.querySelector('.sb-card-original-image');
            const variantImg = mediaWrapper.querySelector('.sb-card-variant-image');
            if (originalImg) originalImg.src = originalImage;
            // Always hide variant image
            if (variantImg) {
              variantImg.style.display = 'none';
            }
          }
        } catch (err) {
          console.warn('Failed to load initial variant image for', handle, err);
        }
      }
      setBrowseCardSize(card, state.preferredSize);
      $$('[data-browse-size]', card).forEach(btn => {
        btn.addEventListener('click', () => {
          const chosen = btn.dataset.browseSize;
          setBrowseCardSize(card, chosen);
        });
      });
    }
  }

  function persistContext() {
    try {
      const ctx = JSON.parse(sessionStorage.getItem('fq:subscription-context') || '{}');
      ctx.preferredSize = state.preferredSize;
      ctx.planCount = state.planCount;
      ctx.refreshMode = state.refreshMode;
      ctx.selectedHandles = Array.from(state.selections.entries())
        .map(([handle, sel]) => ({
          handle,
          size: sel.chosenSize,
          selected: !!sel.selected,
          personalization: sel.personalization || null,
          manualOverride: !!sel.manualOverride
        }));
      sessionStorage.setItem('fq:subscription-context', JSON.stringify(ctx));
    } catch (_) {}
  }

  function readQuizContext() {
    try {
      const ctxStr = sessionStorage.getItem('fq:subscription-context') || '{}';
      const ctx = JSON.parse(ctxStr);
      const nextRecommendations = [];

      if (Array.isArray(ctx.recommended) && ctx.recommended.length) {
        ctx.recommended.forEach(item => {
          const handle = typeof item === 'string' ? item : (item && item.handle);
          if (handle) nextRecommendations.push(handle);
        });
      }
      if (ctx.preferredSize) state.preferredSize = String(ctx.preferredSize);
      if (ctx.planCount) state.planCount = Number(ctx.planCount);
      if (ctx.refreshMode) state.refreshMode = ctx.refreshMode;
      if (Array.isArray(ctx.selectedHandles)) {
        ctx.selectedHandles.forEach(entry => {
          if (!entry || !entry.handle) return;
          state._boxByHandle[entry.handle] = {
            size: entry.size || state.preferredSize,
            selected: !!entry.selected,
            personalization: entry.personalization || null,
            manualOverride: !!entry.manualOverride
          };
        });
      }

      const boxStr = sessionStorage.getItem('fq:box') || '[]';
      const box = JSON.parse(boxStr);
        if (Array.isArray(box) && box.length) {
        const handles = box
          .map(item => (typeof item === 'string' ? item : (item && item.handle)))
          .filter(Boolean);

        if (!nextRecommendations.length && handles.length) {
          handles.slice(0, 8).forEach(handle => nextRecommendations.push(handle));
        }

        box.forEach(item => {
          const handle = typeof item === 'string' ? item : (item && item.handle);
          if (!handle) return;
          // Only preserve selection state if it was explicitly saved in selectedHandles
          // Otherwise, quiz results should be unselected by default
          const wasExplicitlySelected = Array.isArray(ctx.selectedHandles) && 
            ctx.selectedHandles.some(e => e && e.handle === handle && e.selected);
          
          if (!state._boxByHandle[handle]) {
            state._boxByHandle[handle] = {
              size: (typeof item === 'object' && item.size) || state.preferredSize,
              selected: wasExplicitlySelected, // Only true if explicitly saved
              personalization: null,
              manualOverride: false
            };
          } else {
            // Only update selection state if it was explicitly saved
            if (wasExplicitlySelected !== undefined) {
              state._boxByHandle[handle].selected = wasExplicitlySelected;
            } else {
              // If not in selectedHandles, ensure it's unselected (quiz results)
              state._boxByHandle[handle].selected = false;
            }
            if (
              typeof item === 'object' &&
              item.size &&
              !state._boxByHandle[handle].manualOverride
            ) {
              state._boxByHandle[handle].size = item.size;
            }
          }
        });
      }

      if (nextRecommendations.length) {
        state.recommendations = nextRecommendations.slice(0, 8);
      }
    } catch (err) {
      console.error('Error reading quiz context:', err);
    }
  }

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Failed to load product ${handle}`);
    return res.json();
  }

  function normalizeSize(text = '') {
    return text.toLowerCase().replace(/\s+/g, '').replace(/-/g, '');
  }

  function mapSizeToVariant(productJson, sizeLabel) {
    const desired = normalizeSize(sizeLabel);
    const variants = productJson.variants || [];
    const sizeIdx = (productJson.options || []).findIndex(option => /size/i.test(option));
    if (sizeIdx >= 0) {
      const match = variants.find(v => normalizeSize(v.options[sizeIdx]) === desired);
      if (match) return match;
    }
    return variants.find(v => normalizeSize(v.title).includes(desired)) || variants[0] || null;
  }

  function sizeInfo(size) {
    return SIZE_INFO[size] || { label: size, note: '' };
  }

  async function getProductData(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);
    const product = await fetchProduct(handle);
    productCache.set(handle, product);
    return product;
  }

  function getOriginalImage(productJson) {
    const featuredImg = productJson?.featured_image || productJson?.images?.[0];
    if (featuredImg) {
      const imgUrl = typeof featuredImg === 'string' ? featuredImg : (featuredImg.src || featuredImg.url || featuredImg);
      return imgUrl && imgUrl.startsWith('http') ? imgUrl : (imgUrl ? `https:${imgUrl}` : '');
    }
    return '';
  }

  function getVariantImage(variant, productJson) {
    if (!variant) {
      return getOriginalImage(productJson);
    }
    
    // Check if variant has an image ID and find it in product images
    if (variant.image_id) {
      const variantImage = productJson?.images?.find(img => {
        // Handle both numeric and string comparisons
        const imgId = typeof img.id === 'string' ? parseInt(img.id, 10) : img.id;
        const varImgId = typeof variant.image_id === 'string' ? parseInt(variant.image_id, 10) : variant.image_id;
        return imgId === varImgId;
      });
      if (variantImage) {
        // Return the image URL - could be src property or the image object itself
        if (typeof variantImage === 'string') {
          const imgUrl = variantImage.startsWith('http') ? variantImage : `https:${variantImage}`;
          return imgUrl;
        }
        const imgUrl = variantImage.src || variantImage.url || variantImage;
        return imgUrl && imgUrl.startsWith('http') ? imgUrl : (imgUrl ? `https:${imgUrl}` : '');
      }
    }
    
    // Check if variant has image property directly
    if (variant.featured_image || variant.image) {
      const img = variant.featured_image || variant.image;
      const imgUrl = typeof img === 'string' ? img : (img.src || img.url || img);
      return imgUrl && imgUrl.startsWith('http') ? imgUrl : (imgUrl ? `https:${imgUrl}` : '');
    }
    
    // Fallback to product featured image
    return getOriginalImage(productJson);
  }

  function renderCard(productJson) {
    const handle = productJson?.handle;
    const stored = state._boxByHandle[handle] || {};
    const chosenSize = stored.size || state.preferredSize;
    const variant = mapSizeToVariant(productJson, chosenSize);
    const originalImage = getOriginalImage(productJson);
    const variantImage = getVariantImage(variant, productJson);

    const entry = {
      product: productJson,
      chosenSize,
      variant,
      originalImage,
      variantImage,
      // Only mark as selected if it was explicitly saved in selectedHandles
      // Quiz results should always start unselected
      selected: !!stored.selected && stored.selected === true,
      personalization: stored.personalization || null,
      manualOverride: !!stored.manualOverride,
      card: null
    };
    state.selections.set(handle, entry);

    const sizeMeta = sizeInfo(chosenSize);
    const card = document.createElement('div');
    card.className = `sb-card${entry.selected ? ' selected' : ''}`;
    card.dataset.handle = handle;

    const sizeButtons = state.sizeOrder.map(size => {
      const meta = sizeInfo(size);
      return `<button class="sb-card-size-pill ${size === entry.chosenSize ? 'active' : ''}" data-card-size="${size}">
        <span>${meta.label}</span>
        ${meta.note ? `<small>${meta.note}</small>` : ''}
        ${meta.badge ? `<span class="sb-card-badge">${meta.badge}</span>` : ''}
      </button>`;
    }).join('');

    // Never show variant image - only show main product image
    const shouldShowVariantImage = false;
    
    card.innerHTML = `
      <div class="sb-card-media-wrapper" style="position: relative; width: 100%; padding-bottom: 100%; overflow: hidden;">
        <img class="sb-card-media sb-card-original-image" src="${originalImage}" alt="" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: contain; transition: opacity 0.4s ease-in-out;">
      </div>
      <div class="sb-card-body">
        <div class="sb-title-row">
          <div class="sb-card-title">${escapeHtml(productJson.title)}</div>
          <div class="sb-price" data-price>${variant ? toMoney(variant.price) : ''}</div>
        </div>
        <div class="sb-card-size-display">
          <span data-card-size>${sizeMeta.label}</span>
          <span class="sb-card-size-note" data-card-size-note>${sizeMeta.note || ''}</span>
        </div>
        <div class="sb-card-size-row" data-card-size-row>
          ${sizeButtons}
        </div>
        <div class="sb-actions">
          <button class="sb-personalize" data-personalize style="${entry.chosenSize === '10ml' ? '' : 'display:none;'}">${entry.personalization ? 'Edit Customization' : 'Customize your Atomizer + ($4.99)'}</button>
          <button class="sb-pill" data-toggle-select>${entry.selected ? 'Selected' : 'Select'}</button>
        </div>
      </div>
    `;

    entry.card = card;

    card.addEventListener('click', (event) => {
      const target = event.target;
      const personalizeBtn = target.closest?.('[data-personalize]');
      if (personalizeBtn) {
        if (entry.chosenSize !== '10ml') {
          showHint('Customization is available for 10 ml atomizers only.');
        return;
      }
        openEntryCustomizer(entry, personalizeBtn);
        return;
      }

      const sizeBtn = target.closest?.('[data-card-size]');
      if (sizeBtn) {
        const newSize = sizeBtn.dataset.cardSize;
        if (!newSize || newSize === entry.chosenSize) return;
        entry.chosenSize = newSize;
        entry.variant = mapSizeToVariant(entry.product, newSize);
        entry.variantImage = getVariantImage(entry.variant, entry.product);
        entry.originalImage = getOriginalImage(entry.product);
        entry.personalization = newSize === '10ml' ? entry.personalization : null;
        entry.manualOverride = true;
        updateCardSizeUI(entry);
        updateSummary();
        persistContext();
        return;
      }

      const toggleBtn = target.closest?.('[data-toggle-select]');
      if (toggleBtn) {
        event.preventDefault();
        event.stopPropagation();
        entry.selected = !entry.selected;
        card.classList.toggle('selected', entry.selected);
        toggleBtn.textContent = entry.selected ? 'Selected' : 'Select';
        updateSummary();
        persistContext();
        return;
      }
    });

    if (grid) {
    grid.appendChild(card);
    } else {
      console.warn('subscription-builder: recommendation grid missing; card will not be rendered visually.');
    }
    updateCardSizeUI(entry);
    return entry;
  }

  function updateCardSizeUI(entry) {
    if (!entry.card) return;
    const meta = sizeInfo(entry.chosenSize);
    const sizeEl = entry.card.querySelector('[data-card-size]');
    const noteEl = entry.card.querySelector('[data-card-size-note]');
    const badgeEl = entry.card.querySelector('[data-card-size-badge]');
    if (sizeEl) sizeEl.textContent = meta.label;
    if (noteEl) noteEl.textContent = meta.note || '';
    if (meta.badge) {
      if (badgeEl) {
        badgeEl.textContent = meta.badge;
      } else {
        const badge = document.createElement('span');
        badge.className = 'sb-card-badge';
        badge.setAttribute('data-card-size-badge', '');
        badge.textContent = meta.badge;
        entry.card.querySelector('.sb-card-size-display')?.appendChild(badge);
      }
    } else if (badgeEl) {
      badgeEl.remove();
    }
    const priceEl = entry.card.querySelector('[data-price]');
    if (priceEl && entry.variant) priceEl.textContent = toMoney(entry.variant.price);
    
    // Update images with smooth transition
    const originalImageEl = entry.card.querySelector('.sb-card-original-image');
    const variantImageEl = entry.card.querySelector('.sb-card-variant-image');
    
    if (originalImageEl && entry.originalImage) {
      originalImageEl.style.opacity = '0';
      setTimeout(() => {
        originalImageEl.src = entry.originalImage;
        originalImageEl.style.opacity = '1';
      }, 200);
    }
    
    // Never show variant image - only show main product image
    const shouldShowVariantImage = false;
    
    if (variantImageEl) {
      if (shouldShowVariantImage && entry.variantImage) {
        variantImageEl.style.display = 'block';
        variantImageEl.style.opacity = '0';
        setTimeout(() => {
          variantImageEl.src = entry.variantImage;
          variantImageEl.style.opacity = '1';
        }, 200);
      } else {
        variantImageEl.style.display = 'none';
      }
    }
    
    const sizeRow = entry.card.querySelector('[data-card-size-row]');
    if (sizeRow) {
      $$('[data-card-size]', sizeRow).forEach(btn => {
        btn.classList.toggle('active', btn.dataset.cardSize === entry.chosenSize);
      });
    }
    const personalizeBtn = entry.card.querySelector('[data-personalize]');
    if (personalizeBtn) {
      if (entry.chosenSize === '10ml') {
        personalizeBtn.style.display = '';
        personalizeBtn.textContent = entry.personalization ? 'Edit Customization' : 'Customize your Atomizer + ($4.99)';
      } else {
        personalizeBtn.style.display = 'none';
        entry.personalization = null;
      }
    }
  }

  function setPreferredSize(size, forceAll = false) {
    if (!size) return;
    if (!forceAll && size === state.preferredSize) return;
    state.preferredSize = size;
    state.selections.forEach(entry => {
      if (!forceAll && entry.manualOverride) return;
      entry.chosenSize = size;
      entry.variant = mapSizeToVariant(entry.product, size);
      entry.variantImage = getVariantImage(entry.variant, entry.product);
      entry.originalImage = getOriginalImage(entry.product);
      entry.manualOverride = false;
      updateCardSizeUI(entry);
    });
    if (sizePicker) {
      $$('[data-size-option]', sizePicker).forEach(btn => {
        btn.classList.toggle('active', btn.dataset.size === size);
      });
    }
    updateSummary();
    persistContext();
  }

  function initSizePicker() {
    if (!sizePicker) return;
    $$('[data-size-option]', sizePicker).forEach(btn => {
      btn.addEventListener('click', () => setPreferredSize(btn.dataset.size, true));
    });
    setPreferredSize(state.preferredSize, true);
  }

  function updateSummary() {
    const selected = Array.from(state.selections.values()).filter(sel => sel.selected);
    
    console.log('📊 Update Summary - Selected items:', selected.length);
    console.log('📊 Selected items details:', selected.map(s => ({
      title: s.product?.title,
      handle: s.product?.handle,
      size: s.chosenSize,
      hasPersonalization: !!s.personalization
    })));
    
    if (summaryCount) summaryCount.textContent = String(selected.length);
    if (summaryTotal) {
      const meta = sizeInfo(state.preferredSize);
      summaryTotal.textContent = selected.length
        ? `${selected.length} selected • ${meta.label}`
        : `0 selected`;
    }
    updateProgress(selected.length);
    if (submitBtn) {
    submitBtn.disabled = selected.length === 0;
      submitBtn.style.pointerEvents = selected.length === 0 ? 'none' : 'auto';
      submitBtn.style.opacity = selected.length === 0 ? '0.5' : '1';
      console.log('📊 Submit button disabled:', submitBtn.disabled, 'Selected count:', selected.length);
    }
    if (selectionList) {
      if (selected.length) {
        selectionList.classList.add('active');
        selectionList.innerHTML = selected.map((sel, idx) => {
          const meta = sizeInfo(sel.chosenSize);
          let customizationInfo = '';
          if (sel.personalization) {
            const customParts = [];
            if (sel.personalization.textContent && sel.personalization.textContent.trim() !== '') {
              customParts.push(`Text: "${sel.personalization.textContent.substring(0, 20)}${sel.personalization.textContent.length > 20 ? '...' : ''}"`);
            }
            if (sel.personalization.iconFilename) {
              customParts.push('Icon');
            }
            if (sel.personalization.logoFilename) {
              customParts.push('Logo');
            }
            if (customParts.length > 0) {
              customizationInfo = ` • Customized: ${customParts.join(', ')}`;
            } else {
              customizationInfo = ' • Customized';
            }
          }
          return `<div class="sb-selection-item">
            <div>
              <div class="sb-selection-item-title">${escapeHtml(sel.product.title)}</div>
              <div class="sb-selection-item-meta">${meta.label}${customizationInfo}</div>
            </div>
            <div class="sb-selection-item-meta">${idx + 1}</div>
          </div>`;
        }).join('');
      } else {
        selectionList.classList.remove('active');
        selectionList.innerHTML = '';
        if (selectionEmpty) selectionList.appendChild(selectionEmpty);
      }
    }
    if (selectionEmpty) selectionEmpty.style.display = selected.length ? 'none' : '';
    syncBrowseButtons();
    if (selected.length > 0) {
      showHint('');
    } else {
      showHint('Select at least one scent to continue', 0);
    }
  }

  function bindControls() {
    if (planCountWrap) {
      const planButtons = $$('.sb-pill', planCountWrap);
      planButtons.forEach(btn => {
        btn.classList.toggle('active', Number(btn.dataset.count) === state.planCount);
        btn.addEventListener('click', () => {
          const newCount = Number(btn.dataset.count);
          if (!newCount || newCount === state.planCount) return;
          state.planCount = newCount;
          planButtons.forEach(b => b.classList.toggle('active', b === btn));
        updateSummary();
          persistContext();
        });
      });
    }

    if (refreshWrap) {
      const refreshButtons = $$('[data-refresh-option]', refreshWrap);
      refreshButtons.forEach(btn => {
        const option = btn.dataset.refreshOption || 'same';
        btn.classList.toggle('active', option === state.refreshMode);
        btn.addEventListener('click', () => {
          if (state.refreshMode === option) return;
          state.refreshMode = option;
          refreshButtons.forEach(b => b.classList.toggle('active', b === btn));
          persistContext();
      });
    });
    }

    // Setup both buttons independently - query DOM directly each time
    setupButtons();
  }
  
  function setupButtons() {
    // Find buttons directly from DOM each time
    const submitBtnEl = $('[data-add-to-cart]', el);
    const resetBtnEl = $('[data-reset-builder]', el);
    
    // Setup submit button
    if (submitBtnEl) {
      console.log('✅ Found submit button, setting up...');
      setupSubmitButton(submitBtnEl);
    } else {
      console.error('❌ Submit button not found! Looking for [data-add-to-cart] in:', el);
      // Retry after a delay
      setTimeout(() => {
        const retrySubmitBtn = $('[data-add-to-cart]', el);
        if (retrySubmitBtn) {
          console.log('✅ Found submit button on retry');
          setupSubmitButton(retrySubmitBtn);
        } else {
          console.error('❌ Submit button still not found after retry');
        }
      }, 1000);
    }
    
    // Setup reset button independently
    if (resetBtnEl) {
      console.log('✅ Found reset button, setting up...');
      setupResetButton(resetBtnEl);
    } else {
      console.warn('⚠️ Reset button not found! Looking for [data-reset-builder] in:', el);
      // Retry after a delay
      setTimeout(() => {
        const retryResetBtn = $('[data-reset-builder]', el);
        if (retryResetBtn) {
          console.log('✅ Found reset button on retry');
          setupResetButton(retryResetBtn);
        } else {
          console.warn('⚠️ Reset button still not found after retry');
        }
      }, 1000);
    }
  }

  function setupSubmitButton(btn) {
    if (!btn) {
      console.error('❌ Cannot setup submit button: button is null');
      return;
    }
    
    // Check if already set up to avoid infinite loops
    if (btn.hasAttribute('data-sb-setup') && btn.getAttribute('data-sb-setup') === 'true') {
      console.log('✅ Submit button already set up, skipping...');
      return;
    }

    // Remove any existing event listeners by cloning the button
    const newSubmitBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newSubmitBtn, btn);
    
    newSubmitBtn.textContent = 'Add to Cart';
    newSubmitBtn.style.pointerEvents = 'auto';
    newSubmitBtn.style.cursor = 'pointer';
    newSubmitBtn.style.position = 'relative';
    newSubmitBtn.style.zIndex = '1000';
    newSubmitBtn.removeAttribute('disabled');
    newSubmitBtn.setAttribute('data-sb-setup', 'true'); // Mark as set up
    
    // Ensure button is not blocked by any parent elements
    let parent = newSubmitBtn.parentElement;
    while (parent && parent !== document.body) {
      const parentStyle = window.getComputedStyle(parent);
      if (parentStyle.pointerEvents === 'none') {
        parent.style.pointerEvents = 'auto';
        console.warn('⚠️ Submit button parent element had pointer-events: none, fixed:', parent);
      }
      parent = parent.parentElement;
    }
    
    console.log('✅ Setting up submit button:', newSubmitBtn);
    
    newSubmitBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      
      console.log('🛒 Add to Cart button clicked');
      
      const picks = Array.from(state.selections.values()).filter(sel => sel.selected);
      if (picks.length === 0) {
        showHint('Please select at least one scent to continue');
        return;
      }
      
      console.log('🛒 Selected items:', picks.length);
      
      // Check if any items have customization
      const hasCustomization = picks.some(pick => pick.chosenSize === '10ml' && pick.personalization);
      console.log('🛒 Has customization:', hasCustomization);
      
      // If there's customization, show disclaimer popup first
      if (hasCustomization) {
        try {
          if (window.PerfumeCustomizer?.Individual?.showDisclaimerPopup) {
            console.log('🛒 Showing disclaimer popup...');
            
            // Setup disclaimer confirmation callback
            const setupDisclaimerCallback = () => {
              try {
                const checkbox = document.getElementById('pc-disclaimer-checkbox');
                const confirmBtn = document.getElementById('pc-disclaimer-confirm-btn');
                const closeBtn = document.querySelector('.pc-disclaimer-popup-close');
                
                console.log('🛒 Setting up disclaimer callback...', { checkbox: !!checkbox, confirmBtn: !!confirmBtn });
                
                if (!confirmBtn || !checkbox) {
                  console.error('❌ Disclaimer elements not found, falling back to confirm');
                  // Fallback if elements not found
                  const customizationCount = picks.filter(p => p.chosenSize === '10ml' && p.personalization).length;
                  const customizationFee = customizationCount > 0 ? `\n\nCustomization fees: $${(customizationCount * 4.99).toFixed(2)}` : '';
                  const disclaimerText = customizationCount > 0 ? 
                    `\n\n--- CUSTOMIZATION TERMS ---\n\nI confirm that I've reviewed and approved my customization — including the text, icons or logo, placement on the bottle, and style and color choices. I understand that creating my personalized bottle may take an additional 1–2 business days. I also acknowledge that customized items are made uniquely for me and therefore cannot be returned, exchanged, or refunded.\n\nDo you understand and accept these terms?` : '';
                  const message = `Add ${picks.length} item${picks.length > 1 ? 's' : ''} to cart?${customizationFee}${disclaimerText}`;
                  if (confirm(message)) {
                    onSubmit();
                  }
                  return;
                }
                
                // Remove existing listeners to avoid duplicates
                const newConfirmBtn = confirmBtn.cloneNode(true);
                confirmBtn.parentNode.replaceChild(newConfirmBtn, confirmBtn);
                
                const newCheckbox = checkbox.cloneNode(true);
                checkbox.parentNode.replaceChild(newCheckbox, checkbox);
                
                // Setup checkbox
                newCheckbox.addEventListener('change', () => {
                  newConfirmBtn.disabled = !newCheckbox.checked;
                });
                
                // Setup confirm button
                newConfirmBtn.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  console.log('🛒 Disclaimer confirm button clicked');
                  if (!newConfirmBtn.disabled && newCheckbox.checked) {
                    // Close disclaimer (always show it next time, no "don't ask again")
                    if (window.PerfumeCustomizer?.Individual?.closeDisclaimerPopup) {
                      window.PerfumeCustomizer.Individual.closeDisclaimerPopup();
                    }
                    // Proceed to add to cart
                    console.log('🛒 Proceeding to add to cart after disclaimer confirmation');
                    onSubmit();
                  }
                });
                
                // Setup close button to cancel
                if (closeBtn) {
                  const newCloseBtn = closeBtn.cloneNode(true);
                  closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
                  newCloseBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (window.PerfumeCustomizer?.Individual?.closeDisclaimerPopup) {
                      window.PerfumeCustomizer.Individual.closeDisclaimerPopup();
                    }
                  });
                }
                
                console.log('✅ Disclaimer callback setup complete');
              } catch (error) {
                console.error('❌ Error setting up disclaimer callback:', error);
                // Fallback to simple confirm
                const customizationCount = picks.filter(p => p.chosenSize === '10ml' && p.personalization).length;
                const customizationFee = customizationCount > 0 ? `\n\nCustomization fees: $${(customizationCount * 4.99).toFixed(2)}` : '';
                const disclaimerText = customizationCount > 0 ? 
                  `\n\n--- CUSTOMIZATION TERMS ---\n\nI confirm that I've reviewed and approved my customization — including the text, icons or logo, placement on the bottle, and style and color choices. I understand that creating my personalized bottle may take an additional 1–2 business days. I also acknowledge that customized items are made uniquely for me and therefore cannot be returned, exchanged, or refunded.\n\nDo you understand and accept these terms?` : '';
                const message = `Add ${picks.length} item${picks.length > 1 ? 's' : ''} to cart?${customizationFee}${disclaimerText}`;
                if (confirm(message)) {
                  onSubmit();
                }
              }
            };
            
            // Show disclaimer and setup callback
            window.PerfumeCustomizer.Individual.showDisclaimerPopup();
            setTimeout(setupDisclaimerCallback, 200); // Increased timeout to ensure popup is rendered
          } else {
            console.warn('⚠️ Disclaimer popup not available, using simple confirm with disclaimer text');
            // Fallback to simple confirmation if disclaimer not available
            const customizationCount = picks.filter(p => p.chosenSize === '10ml' && p.personalization).length;
            const customizationFee = customizationCount > 0 ? `\n\nCustomization fees: $${(customizationCount * 4.99).toFixed(2)}` : '';
            const disclaimerText = customizationCount > 0 ? 
              `\n\n--- CUSTOMIZATION TERMS ---\n\nI confirm that I've reviewed and approved my customization — including the text, icons or logo, placement on the bottle, and style and color choices. I understand that creating my personalized bottle may take an additional 1–2 business days. I also acknowledge that customized items are made uniquely for me and therefore cannot be returned, exchanged, or refunded.\n\nDo you understand and accept these terms?` : '';
            const message = `Add ${picks.length} item${picks.length > 1 ? 's' : ''} to cart?${customizationFee}${disclaimerText}`;
            if (confirm(message)) {
              onSubmit();
            }
          }
        } catch (error) {
          console.error('❌ Error showing disclaimer:', error);
          // Fallback to simple confirm on error
          const customizationCount = picks.filter(p => p.chosenSize === '10ml' && p.personalization).length;
          const customizationFee = customizationCount > 0 ? `\n\nCustomization fees: $${(customizationCount * 4.99).toFixed(2)}` : '';
          const message = `Add ${picks.length} item${picks.length > 1 ? 's' : ''} to cart?${customizationFee}`;
          if (confirm(message)) {
            onSubmit();
          }
        }
      } else {
        // No customization, proceed directly with simple confirmation
        const message = `Add ${picks.length} item${picks.length > 1 ? 's' : ''} to cart?`;
        if (confirm(message)) {
          onSubmit();
        }
      }
    });

  }
  
  function setupResetButton(btn) {
    if (!btn) {
      console.error('❌ Cannot setup reset button: button is null');
      return;
    }
    
    // Check if already set up to avoid infinite loops
    if (btn.hasAttribute('data-sb-setup') && btn.getAttribute('data-sb-setup') === 'true') {
      console.log('✅ Reset button already set up, skipping...');
      return;
    }
    
    // Remove existing listeners by cloning
    const newResetBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newResetBtn, btn);
    
    newResetBtn.style.pointerEvents = 'auto';
    newResetBtn.style.cursor = 'pointer';
    newResetBtn.style.position = 'relative';
    newResetBtn.style.zIndex = '1000';
    newResetBtn.removeAttribute('disabled');
    newResetBtn.setAttribute('data-sb-setup', 'true'); // Mark as set up
    
    // Ensure button is not blocked by any parent elements
    let parent = newResetBtn.parentElement;
    while (parent && parent !== document.body) {
      const parentStyle = window.getComputedStyle(parent);
      if (parentStyle.pointerEvents === 'none') {
        parent.style.pointerEvents = 'auto';
        console.warn('⚠️ Reset button parent element had pointer-events: none, fixed:', parent);
      }
      parent = parent.parentElement;
    }
    
    console.log('✅ Setting up reset button:', newResetBtn);
    
    newResetBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      console.log('🔄 Reset button clicked');
        if (confirm('Are you sure you want to start from scratch? This will clear all your selections.')) {
          resetBuilder();
        }
      });
    
    console.log('✅ Reset button setup complete');
  }

  function resetBuilder() {
    // Clear all selections
    state.selections.forEach((entry, handle) => {
      entry.selected = false;
      entry.personalization = null;
      if (entry.card) {
        entry.card.classList.remove('selected');
        const toggle = entry.card.querySelector('[data-toggle-select]');
        if (toggle) toggle.textContent = 'Select';
        const personalizeBtn = entry.card.querySelector('[data-personalize]');
        if (personalizeBtn) personalizeBtn.textContent = 'Customize your Atomizer + ($4.99)';
      }
    });

    // Clear browse buttons
    $$('[data-browse-handle]', el).forEach(btn => {
      btn.classList.remove('is-selected');
      btn.textContent = 'Select scent';
      btn.disabled = false;
    });
    
    // Clear pending personalizations
    Object.keys(pendingBrowsePersonalizations).forEach(key => {
      delete pendingBrowsePersonalizations[key];
    });
    
    // Clear sessionStorage
    try {
      const ctx = JSON.parse(sessionStorage.getItem('fq:subscription-context') || '{}');
      ctx.selectedHandles = [];
      sessionStorage.setItem('fq:subscription-context', JSON.stringify(ctx));
    } catch (_) {}
    
    // Update UI
    updateSummary();
    updateProgress(0);
    showHint('All selections cleared. Start fresh!', 2000);
  }

  async function attachSellingPlan(variantId) {
    if (state.monthlyPlanId) return state.monthlyPlanId;
    try {
      if (window.Appstle && typeof window.Appstle.getDefaultPlanId === 'function') {
        const planId = normalizePlanId(await window.Appstle.getDefaultPlanId(variantId));
        if (planId) return planId;
      }
    } catch (_) {}
    return '';
  }

  // Simple confirmation - no blocking modal
  // (Modal code removed to prevent page blocking issues)

  async function onSubmit() {
    console.log('🛒 Add to Cart button clicked');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding...';
    submitHint.textContent = '';
    try {
      const picks = Array.from(state.selections.values()).filter(sel => sel.selected);
      console.log('🛒 Selected items for cart:', picks.length);
      console.log('🛒 Picks details:', picks.map(p => ({
        title: p.product?.title,
        handle: p.product?.handle,
        size: p.chosenSize,
        variantId: p.variant?.id,
        hasPersonalization: !!p.personalization
      })));
      
      if (picks.length === 0) {
        showHint('Please select at least one scent to continue');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add to Cart';
        return;
      }
      
      const summary = picks.map((pick, idx) => `${idx + 1}. ${pick.product.title} (${pick.chosenSize})`).join('; ');
      console.log('🛒 Cart summary:', summary);
      for (let i = 0; i < picks.length; i++) {
        const pick = picks[i];
        const planId = await attachSellingPlan(pick.variant.id);
        const properties = {
          'Builder Plan Count': String(state.planCount),
          'Builder Selection Index': String(i + 1),
          'Chosen Size': pick.chosenSize,
          'Selected Scents': summary,
          'Refresh Mode': state.refreshMode
        };
        if (pick.chosenSize === '10ml' && pick.personalization) {
          properties['Personalization'] = JSON.stringify(pick.personalization);
          properties['Customization Fee'] = '$4.99';
          
          // PRIORITY: Use print area PNG URL (not preview) for cart
          const printAreaUrl = pick.personalization.printAreaImageUrl || pick.personalization.printAreaPNG || pick.personalization.printImage;
          const previewUrl = pick.personalization.previewImageUrl || pick.personalization.previewImage;
          
          // Always prioritize print area PNG over preview image
          const imageUrl = printAreaUrl || previewUrl;
          if (imageUrl && imageUrl.trim() !== '') {
            properties['Preview Image URL'] = imageUrl.substring(0, 1000);
            // Store which type was used for debugging
            if (printAreaUrl) {
              properties['Image Type'] = 'Print Area PNG';
              console.log('✅ Using Print Area PNG for cart:', printAreaUrl.substring(0, 80));
            } else {
              properties['Image Type'] = 'Preview (fallback)';
              console.warn('⚠️ Print Area PNG not available, using preview:', previewUrl?.substring(0, 80));
            }
          } else {
            console.warn('⚠️ No image URL available in personalization');
          }
        }
        const payload = {
          id: pick.variant.id,
          quantity: 1,
          properties
        };
        if (planId) payload.selling_plan = planId;
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload),
          credentials: 'same-origin'
        });
        if (!res.ok) {
          const text = await res.text();
          let friendlyMsg = 'Failed to add item to cart. Please try again.';
          try {
            const errJson = JSON.parse(text);
            if (errJson.description && errJson.description.includes('sold out')) {
              friendlyMsg = 'This product is currently sold out. Please try a different size or contact us.';
            } else if (errJson.message) {
              friendlyMsg = errJson.message;
            }
          } catch (_) {}
          throw new Error(friendlyMsg);
        }
        const addResult = await res.json();
        console.log(`✅ Added item ${i + 1} to cart:`, addResult);
        
        // If item has customization, add the customization fee as separate line item
        if (pick.chosenSize === '10ml' && pick.personalization) {
          const customizationFeeVariantId = window.PerfumeCustomizer?.config?.customizationFeeVariantId || 50856845574442;
          console.log('💰 Adding customization fee for item:', pick.product.title);
          
          try {
            const feeItem = {
              id: typeof customizationFeeVariantId === 'string' ? parseInt(customizationFeeVariantId, 10) : customizationFeeVariantId,
              quantity: 1,
              properties: {
                'Order Type': 'Customization Fee',
                'Associated Product': (pick.product?.title || '').substring(0, 100),
                'Associated Variant': (pick.variant?.title || '').substring(0, 50),
                'Builder Selection Index': String(i + 1)
              }
            };
            
            const feeResponse = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify(feeItem),
              credentials: 'same-origin'
            });
            
            if (feeResponse.ok) {
              const feeResult = await feeResponse.json();
              console.log('✅ Customization fee ($4.99) added to cart:', feeResult);
            } else {
              const errorText = await feeResponse.text();
              console.error('❌ Failed to add customization fee:', errorText);
              // Don't throw - continue with other items
            }
            
            // Small delay between items
            await new Promise(resolve => setTimeout(resolve, 200));
          } catch (feeError) {
            console.error('❌ Error adding customization fee:', feeError);
            // Continue with next item
          }
        }
      }
      
      // Check if any items have customization
      const hasCustomization = picks.some(pick => pick.chosenSize === '10ml' && pick.personalization);
      
      sessionStorage.removeItem('fq:box');
      
      // Wait a bit to ensure all cart additions are processed on the server
      console.log('⏳ Waiting for cart to be fully updated...');
      await new Promise(resolve => setTimeout(resolve, 500));
      
      // Now refresh and open the cart drawer
      await refreshCartDrawer();
      
      // Note: Disclaimer popup is shown BEFORE adding to cart, not after
      // It's already been shown and confirmed before reaching here
      
      submitBtn.textContent = 'Added!';
      
      // Reset selections after successful cart addition (keep personalizations for editing)
        setTimeout(() => {
        resetSelections();
      }, 500);
      
      setTimeout(() => {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add to Cart';
      }, 1800);
    } catch (error) {
      console.error(error);
      submitHint.textContent = error?.message || 'There was a problem adding your subscription. Please try again.';
      submitBtn.disabled = false;
      submitBtn.textContent = 'Add to Cart';
    }
  }

  async function addIndividualItemToCart(handle, button) {
    if (!handle) {
      console.error('❌ No handle provided for individual add to cart');
      return;
    }

    // Disable button and show loading state
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
      button.classList.add('is-loading');
    }

    try {
      // Get or create entry for this product
      let entry = state.selections.get(handle);
      if (!entry) {
        try {
          const product = await fetchProduct(handle);
          entry = renderCard(product);
          if (!entry) {
            throw new Error('Unable to prepare selection card.');
          }
        } catch (err) {
          console.warn('Failed to load scent', handle, err);
          if (button) {
            button.classList.remove('is-loading');
            button.disabled = false;
            button.textContent = 'Add to Cart';
          }
          alert('Unable to load that scent. Please try again.');
          return;
        }
      }
      
      if (!entry) {
        if (button) {
          button.classList.remove('is-loading');
          button.disabled = false;
          button.textContent = 'Add to Cart';
        }
        return;
      }

      // Get selected size from card or use default
      const browseCard = button?.closest('.sb-card--browse');
      const selectedSize = browseCard?.dataset.selectedSize || state.preferredSize;
      
      // Update entry with selected size
      entry.chosenSize = selectedSize;
      entry.variant = mapSizeToVariant(entry.product, entry.chosenSize);
      entry.variantImage = getVariantImage(entry.variant, entry.product);
      entry.originalImage = getOriginalImage(entry.product);

      // Check for personalization (from pending or existing)
      if (entry.chosenSize === '10ml' && pendingBrowsePersonalizations[handle]) {
        entry.personalization = pendingBrowsePersonalizations[handle];
        delete pendingBrowsePersonalizations[handle];
      }

      const hasPersonalization = entry.chosenSize === '10ml' && entry.personalization;

      // Show disclaimer if customization exists
      if (hasPersonalization) {
        try {
          if (window.PerfumeCustomizer?.Individual?.showDisclaimerPopup) {
            const proceed = await new Promise((resolve) => {
              const setupDisclaimerCallback = () => {
                try {
                  const checkbox = document.getElementById('pc-disclaimer-checkbox');
                  const confirmBtn = document.getElementById('pc-disclaimer-confirm-btn');
                  const closeBtn = document.querySelector('.pc-disclaimer-popup-close');
                  
                  if (!confirmBtn || !checkbox) {
                    const message = `\n\n--- CUSTOMIZATION TERMS ---\n\nI confirm that I've reviewed and approved my customization — including the text, icons or logo, placement on the bottle, and style and color choices. I understand that creating my personalized bottle may take an additional 1–2 business days. I also acknowledge that customized items are made uniquely for me and therefore cannot be returned, exchanged, or refunded.\n\nDo you understand and accept these terms?`;
                    if (confirm(message)) {
                      resolve(true);
                    } else {
                      resolve(false);
                    }
                    return;
                  }
                  
                  const newConfirmBtn = confirmBtn.cloneNode(true);
                  confirmBtn.parentNode.replaceChild(newConfirmBtn, confirmBtn);
                  
                  const newCheckbox = checkbox.cloneNode(true);
                  checkbox.parentNode.replaceChild(newCheckbox, checkbox);
                  
                  newCheckbox.addEventListener('change', () => {
                    newConfirmBtn.disabled = !newCheckbox.checked;
                  });
                  
                  newConfirmBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (!newConfirmBtn.disabled && newCheckbox.checked) {
                      if (window.PerfumeCustomizer?.Individual?.closeDisclaimerPopup) {
                        window.PerfumeCustomizer.Individual.closeDisclaimerPopup();
                      }
                      resolve(true);
                    }
                  });
                  
                  if (closeBtn) {
                    const newCloseBtn = closeBtn.cloneNode(true);
                    closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);
                    newCloseBtn.addEventListener('click', (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (window.PerfumeCustomizer?.Individual?.closeDisclaimerPopup) {
                        window.PerfumeCustomizer.Individual.closeDisclaimerPopup();
                      }
                      resolve(false);
                    });
                  }
                } catch (error) {
                  console.error('Error setting up disclaimer:', error);
                  const message = `\n\n--- CUSTOMIZATION TERMS ---\n\nI confirm that I've reviewed and approved my customization — including the text, icons or logo, placement on the bottle, and style and color choices. I understand that creating my personalized bottle may take an additional 1–2 business days. I also acknowledge that customized items are made uniquely for me and therefore cannot be returned, exchanged, or refunded.\n\nDo you understand and accept these terms?`;
                  resolve(confirm(message));
                }
              };
              
              window.PerfumeCustomizer.Individual.showDisclaimerPopup();
              setTimeout(setupDisclaimerCallback, 200);
            });

            if (!proceed) {
              if (button) {
                button.disabled = false;
                button.textContent = 'Add to Cart';
                button.classList.remove('is-loading');
              }
              return;
            }
          } else {
            const message = `\n\n--- CUSTOMIZATION TERMS ---\n\nI confirm that I've reviewed and approved my customization — including the text, icons or logo, placement on the bottle, and style and color choices. I understand that creating my personalized bottle may take an additional 1–2 business days. I also acknowledge that customized items are made uniquely for me and therefore cannot be returned, exchanged, or refunded.\n\nDo you understand and accept these terms?`;
            if (!confirm(message)) {
              if (button) {
                button.disabled = false;
                button.textContent = 'Add to Cart';
                button.classList.remove('is-loading');
              }
              return;
            }
          }
        } catch (error) {
          console.error('Error showing disclaimer:', error);
          const message = `\n\n--- CUSTOMIZATION TERMS ---\n\nI confirm that I've reviewed and approved my customization — including the text, icons or logo, placement on the bottle, and style and color choices. I understand that creating my personalized bottle may take an additional 1–2 business days. I also acknowledge that customized items are made uniquely for me and therefore cannot be returned, exchanged, or refunded.\n\nDo you understand and accept these terms?`;
          if (!confirm(message)) {
            if (button) {
              button.disabled = false;
              button.textContent = 'Add to Cart';
              button.classList.remove('is-loading');
            }
            return;
          }
        }
      }

      // Prepare cart payload
      const planId = await attachSellingPlan(entry.variant.id);
      const properties = {
        'Builder Plan Count': String(state.planCount),
        'Chosen Size': entry.chosenSize,
        'Refresh Mode': state.refreshMode
      };

      if (hasPersonalization) {
        properties['Personalization'] = JSON.stringify(entry.personalization);
        properties['Customization Fee'] = '$4.99';
        
        const printAreaUrl = entry.personalization.printAreaImageUrl || entry.personalization.printAreaPNG || entry.personalization.printImage;
        const previewUrl = entry.personalization.previewImageUrl || entry.personalization.previewImage;
        const imageUrl = printAreaUrl || previewUrl;
        
        if (imageUrl && imageUrl.trim() !== '') {
          properties['Preview Image URL'] = imageUrl.substring(0, 1000);
          properties['Image Type'] = printAreaUrl ? 'Print Area PNG' : 'Preview (fallback)';
        }
      }

      const payload = {
        id: entry.variant.id,
        quantity: 1,
        properties
      };
      
      if (planId) payload.selling_plan = planId;

      // Add to cart
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      });

      if (!res.ok) {
        const text = await res.text();
        let friendlyMsg = 'Failed to add item to cart. Please try again.';
        try {
          const errJson = JSON.parse(text);
          if (errJson.description && errJson.description.includes('sold out')) {
            friendlyMsg = 'This product is currently sold out. Please try a different size or contact us.';
          } else if (errJson.message) {
            friendlyMsg = errJson.message;
          }
        } catch (_) {}
        throw new Error(friendlyMsg);
      }

      const addResult = await res.json();
      console.log('✅ Added item to cart:', addResult);

      // Add customization fee if needed
      if (hasPersonalization) {
        const customizationFeeVariantId = window.PerfumeCustomizer?.config?.customizationFeeVariantId || 50856845574442;
        try {
          const feeItem = {
            id: typeof customizationFeeVariantId === 'string' ? parseInt(customizationFeeVariantId, 10) : customizationFeeVariantId,
            quantity: 1,
            properties: {
              'Order Type': 'Customization Fee',
              'Associated Product': (entry.product?.title || '').substring(0, 100),
              'Associated Variant': (entry.variant?.title || '').substring(0, 50)
            }
          };
          
          const feeResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(feeItem),
            credentials: 'same-origin'
          });
          
          if (feeResponse.ok) {
            const feeResult = await feeResponse.json();
            console.log('✅ Customization fee ($4.99) added to cart:', feeResult);
          } else {
            console.error('❌ Failed to add customization fee');
          }
        } catch (feeError) {
          console.error('❌ Error adding customization fee:', feeError);
        }
      }

      // Wait a bit for cart to update
      await new Promise(resolve => setTimeout(resolve, 300));

      // Refresh cart drawer
      await refreshCartDrawer();

      // Update button state
      if (button) {
        button.textContent = 'Added!';
        button.classList.remove('is-loading');
        setTimeout(() => {
          button.disabled = false;
          button.textContent = 'Add to Cart';
        }, 2000);
      }

    } catch (error) {
      console.error('❌ Error adding item to cart:', error);
      if (button) {
        button.disabled = false;
        button.textContent = 'Add to Cart';
        button.classList.remove('is-loading');
      }
      alert(error?.message || 'There was a problem adding this item to cart. Please try again.');
    }
  }

  async function refreshCartDrawer() {
    try {
      console.log('🛒 Refreshing cart drawer...');
      
      // First, wait a bit to ensure cart is updated on server
      await new Promise(resolve => setTimeout(resolve, 300));
      
      // Fetch cart HTML to update side cart content
      try {
        const cartHtmlResponse = await fetch('/cart?view=ajax_side_cart', { credentials: 'same-origin' });
        if (cartHtmlResponse.ok) {
          const cartHtml = await cartHtmlResponse.text();
          console.log('✅ Fetched cart HTML, updating sidebar content...');
          
          // Try multiple selectors for cart sidebar content
          const sidebarSelectors = [
            '#scoder-cart-sidebar .scoder-sidebar-wrapper .previewCart-wrapper',
            '.cart-sidebar .cart-content',
            '[data-cart-content]',
            '.previewCart-wrapper',
            '.cart-drawer-content',
            '#scoder-cart-sidebar .previewCart-wrapper',
            '.scoder-sidebar-wrapper .previewCart-wrapper'
          ];
          
          let contentUpdated = false;
          for (const selector of sidebarSelectors) {
            const sidebarContent = document.querySelector(selector);
            if (sidebarContent) {
              console.log(`✅ Found sidebar content with selector: ${selector}`);
              sidebarContent.innerHTML = cartHtml;
              contentUpdated = true;
              break;
            }
          }
          
          if (!contentUpdated) {
            console.warn('⚠️ Could not find sidebar content element, trying alternative method');
          }
        } else {
          console.warn('⚠️ Failed to fetch cart HTML:', cartHtmlResponse.status);
        }
      } catch (htmlError) {
        console.warn('⚠️ Error fetching cart HTML:', htmlError);
      }
      
      // Also fetch cart JSON to update cart count and call updateSidebarCart
      let cart;
      if (window.Shopify && typeof Shopify.getCart === 'function') {
        await new Promise((resolve) => {
          Shopify.getCart((cartData) => {
            cart = cartData;
            resolve();
          });
        });
      } else {
        const cartResponse = await fetch('/cart.js', { credentials: 'same-origin' });
        if (cartResponse.ok) {
          cart = await cartResponse.json();
        }
      }
      
      if (cart) {
        console.log('✅ Got cart data, updating sidebar:', cart.item_count, 'items');
        
        // Update cart count
        const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, .cart__count, .header__cart-count, [data-cart-item-count]');
        cartCountElements.forEach(el => {
          if (el) {
            el.textContent = cart.item_count || 0;
            // Also update data attributes if they exist
            if (el.dataset) {
              el.dataset.cartCount = cart.item_count || 0;
            }
          }
        });
        
        // Use theme's updateSidebarCart if available
      if (window.scoder && typeof scoder.updateSidebarCart === 'function') {
          try {
        scoder.updateSidebarCart(cart);
            console.log('✅ Called scoder.updateSidebarCart');
          } catch (e) {
            console.warn('⚠️ Error calling scoder.updateSidebarCart:', e);
          }
        }
        
        // Dispatch cart updated events
        try {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
          window.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
          console.log('✅ Dispatched cart updated events');
        } catch (e) {
          console.warn('⚠️ Error dispatching cart events:', e);
        }
      }
      
      // Wait a bit more to ensure HTML is updated, then open drawer
      await new Promise(resolve => setTimeout(resolve, 200));
      openDrawer();
      console.log('✅ Cart drawer opened');
      
    } catch (error) {
      console.error('❌ Error refreshing cart drawer:', error);
      // Still try to open drawer even if refresh failed
      openDrawer();
    }
  }

  function openDrawer() {
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
    } else {
      document.body.classList.add('cart-sidebar-show');
    }
  }

  async function addProductFromBrowse(handle, presetSize, triggerBtn) {
    if (!handle) return;
    let entry = state.selections.get(handle);
    if (triggerBtn) {
      triggerBtn.classList.add('is-loading');
      triggerBtn.disabled = true;
      triggerBtn.textContent = 'Adding...';
    }
    if (!entry) {
      try {
        const product = await fetchProduct(handle);
        entry = renderCard(product);
        if (!entry) {
          throw new Error('Unable to prepare selection card.');
        }
      } catch (err) {
        console.warn('Failed to load scent', handle, err);
        showHint('Unable to load that scent. Please try again.');
        if (triggerBtn) {
          triggerBtn.classList.remove('is-loading');
          triggerBtn.disabled = false;
          triggerBtn.textContent = 'Select scent';
        }
        return;
      }
    }
    if (!entry) {
      if (triggerBtn) {
        triggerBtn.classList.remove('is-loading');
        triggerBtn.disabled = false;
        triggerBtn.textContent = 'Select scent';
      }
      return;
    }
    // No limit - allow unlimited selections
    entry.chosenSize = presetSize || state.preferredSize;
    entry.variant = mapSizeToVariant(entry.product, entry.chosenSize);
    entry.variantImage = getVariantImage(entry.variant, entry.product);
    entry.originalImage = getOriginalImage(entry.product);
    entry.manualOverride = false;
    entry.selected = true;
    if (entry.chosenSize === '10ml' && pendingBrowsePersonalizations[handle]) {
      entry.personalization = pendingBrowsePersonalizations[handle];
      delete pendingBrowsePersonalizations[handle];
    }
    updateCardSizeUI(entry);
    if (entry.card) {
      entry.card.classList.add('selected');
      const toggle = entry.card.querySelector('[data-toggle-select]');
      if (toggle) toggle.textContent = 'Selected';
    }
    if (empty) empty.style.display = 'none';
    updateSummary();
    persistContext();
    if (triggerBtn) {
      triggerBtn.classList.remove('is-loading');
      triggerBtn.disabled = false;
      triggerBtn.classList.add('is-selected');
      triggerBtn.textContent = 'Selected';
    }
  }

  async function init() {
    initModeSwitch();
    initCategoryNav();
    initBrowseCards();
    readQuizContext();
    bindControls();
    initSizePicker();
    
    // Only show quiz results if they exist
    if (state.recommendations.length && hasQuizPanel) {
      // Show the "Use my quiz matches" button
      const quizToggleBtn = modeButtons.find(btn => btn.dataset.modeToggle === 'quiz');
      if (quizToggleBtn) {
        quizToggleBtn.style.display = '';
      }
      
      // Render quiz recommendation cards
    for (const handle of state.recommendations) {
      try {
          const product = await fetchProduct(handle);
          const entry = renderCard(product);
          // Ensure quiz results start unselected (only select if explicitly saved)
          if (entry && !entry.manualOverride) {
            const ctx = JSON.parse(sessionStorage.getItem('fq:subscription-context') || '{}');
            const wasExplicitlySelected = Array.isArray(ctx.selectedHandles) && 
              ctx.selectedHandles.some(e => e && e.handle === handle && e.selected);
            if (!wasExplicitlySelected) {
              entry.selected = false;
              if (entry.card) {
                entry.card.classList.remove('selected');
                const toggle = entry.card.querySelector('[data-toggle-select]');
                if (toggle) toggle.textContent = 'Select';
              }
              if (state._boxByHandle[handle]) {
                state._boxByHandle[handle].selected = false;
              }
            }
          }
        } catch (err) {
          console.warn('Failed to render recommendation', handle, err);
        }
      }
      
      // Switch to quiz mode and hide empty state
      if (empty && grid && grid.children.length) {
        empty.style.display = 'none';
      }
      setMode('quiz');
    } else {
      // No quiz results - show empty state in quiz panel if it exists
      if (hasQuizPanel && empty) {
        empty.style.display = '';
      }
      // Default to browse mode if available
      if (modeButtons.find(btn => btn.dataset.modeToggle === 'browse')) {
        setMode('browse');
      }
    }
    updateSummary();
  }

  // Listen for quiz completion and update UI
  function handleQuizResultsUpdate(options = {}) {
    const previousHandles = state.recommendations.slice();
    readQuizContext();

    const hasResults = state.recommendations.length > 0;
    const quizToggleBtn = modeButtons.find(btn => btn.dataset.modeToggle === 'quiz');
    if (quizToggleBtn && hasQuizPanel) {
      quizToggleBtn.style.display = hasResults ? '' : 'none';
    }

    if (!hasResults) {
      if (hasQuizPanel && empty) {
        empty.style.display = '';
      }
      return;
    }

    const handlesChanged =
      state.recommendations.length !== previousHandles.length ||
      state.recommendations.some((handle, index) => handle !== previousHandles[index]);

    const shouldRenderAll = options.forceMode || handlesChanged;
    const handlesToRender = shouldRenderAll
      ? state.recommendations.slice()
      : state.recommendations.slice(previousHandles.length);

    if (!handlesToRender.length && !shouldRenderAll) {
      return;
    }

    if (shouldRenderAll && grid) {
      grid.innerHTML = '';
    }

    // Ensure quiz results are not auto-selected
    handlesToRender.forEach(handle => {
      const entry = state.selections.get(handle);
      if (entry && !entry.manualOverride) {
        // Only keep selection if it was explicitly saved in selectedHandles
        const ctx = JSON.parse(sessionStorage.getItem('fq:subscription-context') || '{}');
        const wasExplicitlySelected = Array.isArray(ctx.selectedHandles) && 
          ctx.selectedHandles.some(e => e && e.handle === handle && e.selected);
        if (!wasExplicitlySelected) {
          entry.selected = false;
          if (state._boxByHandle[handle]) {
            state._boxByHandle[handle].selected = false;
          }
        }
      }
    });

    Promise.all(
      handlesToRender.map(handle =>
        fetchProduct(handle)
          .then(product => {
            const entry = renderCard(product);
            // Ensure quiz results start unselected
            if (entry && !entry.manualOverride) {
              const ctx = JSON.parse(sessionStorage.getItem('fq:subscription-context') || '{}');
              const wasExplicitlySelected = Array.isArray(ctx.selectedHandles) && 
                ctx.selectedHandles.some(e => e && e.handle === handle && e.selected);
              if (!wasExplicitlySelected) {
                entry.selected = false;
                if (entry.card) {
                  entry.card.classList.remove('selected');
                  const toggle = entry.card.querySelector('[data-toggle-select]');
                  if (toggle) toggle.textContent = 'Select';
                }
              }
            }
            return entry;
          })
          .catch(err => console.warn('Failed to render recommendation', handle, err))
      )
    ).then(() => {
      if (empty && grid && grid.children.length) {
        empty.style.display = 'none';
      }
      if (shouldRenderAll || handlesToRender.length) {
        setMode('quiz');
      }
      updateSummary();
    });
  }

  // Listen for storage changes (quiz completion)
  window.addEventListener('storage', (e) => {
    if (e.key === 'fq:box' || e.key === 'fq:subscription-context') {
      handleQuizResultsUpdate();
    }
  });

  // Listen for custom quiz completion event
  window.addEventListener('fq:quiz-completed', () => {
    handleQuizResultsUpdate({ forceMode: true });
  });

  // Also check periodically for quiz results (in case storage event doesn't fire)
  let quizCheckInterval = setInterval(() => {
    const box = JSON.parse(sessionStorage.getItem('fq:box') || '[]');
    const ctx = JSON.parse(sessionStorage.getItem('fq:subscription-context') || '{}');
    const hasResults = (Array.isArray(box) && box.length > 0) || 
                      (Array.isArray(ctx.recommended) && ctx.recommended.length > 0);
    if (hasResults && state.recommendations.length === 0) {
      handleQuizResultsUpdate();
    }
  }, 1000);

  // Clear interval after 30 seconds to avoid unnecessary checks
  setTimeout(() => clearInterval(quizCheckInterval), 30000);

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('click', (event) => {
    const browseBtn = event.target.closest('[data-browse-handle]');
    if (browseBtn) {
      event.preventDefault();
      event.stopPropagation();
      const handle = browseBtn.dataset.browseHandle;
      const existing = state.selections.get(handle);
      if (existing?.selected) {
        // Deselect
        existing.selected = false;
        if (existing.card) {
          existing.card.classList.remove('selected');
          const toggle = existing.card.querySelector('[data-toggle-select]');
          if (toggle) toggle.textContent = 'Select';
        }
        browseBtn.classList.remove('is-selected', 'is-loading');
        browseBtn.disabled = false;
        browseBtn.textContent = 'Select scent';
        updateSummary();
        persistContext();
        return;
      }
      // Select
      const browseCard = browseBtn.closest('.sb-card--browse');
      const sizeChoice = browseCard?.dataset.selectedSize || state.preferredSize;
      addProductFromBrowse(browseBtn.dataset.browseHandle, sizeChoice, browseBtn).catch(() => {
        browseBtn.classList.remove('is-loading');
        browseBtn.disabled = false;
        browseBtn.textContent = 'Select scent';
      });
      return;
    }
    const personalizeBrowseBtn = event.target.closest('[data-browse-personalize]');
    if (personalizeBrowseBtn) {
      event.preventDefault();
      handleBrowsePersonalize(personalizeBrowseBtn);
      return;
    }
    const sizeBtn = event.target.closest('[data-browse-size]');
    if (sizeBtn) {
      const browseCard = sizeBtn.closest('.sb-card--browse');
      if (browseCard) {
        setBrowseCardSize(browseCard, sizeBtn.dataset.browseSize);
      }
    }
    const addToCartBtn = event.target.closest('[data-browse-add-to-cart]');
    if (addToCartBtn) {
      event.preventDefault();
      event.stopPropagation();
      const handle = addToCartBtn.dataset.browseAddToCart;
      addIndividualItemToCart(handle, addToCartBtn);
      return;
    }
  });
  
  // Emergency function to remove stuck modals and fix blocked page
  window.__sbCloseAllModals = function() {
    // Remove review modal
    const modal = document.getElementById('sb-review-modal');
    if (modal) {
      modal.remove();
    }
    
    // Remove any loading overlays or blocking elements
    const blockingElements = document.querySelectorAll('.sb-review-modal, .sb-review-overlay, .pc-loading-overlay, [style*="z-index: 10000"]');
    blockingElements.forEach(el => {
      if (el.id === 'sb-review-modal' || el.classList.contains('sb-review-modal') || el.classList.contains('sb-review-overlay')) {
        el.remove();
      }
    });
    
    // Fix body styles
    document.body.style.overflow = '';
    document.body.style.pointerEvents = '';
    document.body.classList.remove('pc-modal-open', 'cart-sidebar-show', 'overflow-hidden');
    
    // Remove any invisible overlays with high z-index
    const allElements = document.querySelectorAll('*');
    allElements.forEach(el => {
      const zIndex = window.getComputedStyle(el).zIndex;
      if (zIndex && parseInt(zIndex) >= 10000 && el.style.position === 'fixed' && el.id !== 'sb-review-modal') {
        // Check if it's covering the whole screen
        const rect = el.getBoundingClientRect();
        if (rect.width >= window.innerWidth - 10 && rect.height >= window.innerHeight - 10) {
          console.warn('Found blocking overlay, removing:', el);
          el.style.display = 'none';
        }
      }
    });
    
    console.log('✅ All modals and blocking elements removed');
    return true;
  };
  
  // Auto-fix: Continuously check for stuck modals and fix them (more frequent for white page issue)
  setInterval(() => {
    // IMMEDIATE CHECK: White page prevention - check modal and body state FIRST
    const whitePageModal = document.getElementById('pc-individual-modal');
    if (whitePageModal) {
      const modalStyle = window.getComputedStyle(whitePageModal);
      const modalIsVisible = (whitePageModal.classList.contains('active') || 
                               modalStyle.display !== 'none') &&
                               modalStyle.position === 'fixed';
      const bodyIsBlocked = document.body.classList.contains('pc-modal-open') || 
                           document.body.style.position === 'fixed';
      
      // If modal is NOT supposed to be open but body is blocked = white page freeze
      if (!whitePageModal.classList.contains('active') && bodyIsBlocked) {
        console.warn('⚠️ WHITE PAGE DETECTED: Body blocked but modal not active, fixing immediately...');
        try {
          // Force unblock everything
          document.body.style.cssText = '';
          document.body.classList.remove('pc-modal-open', 'overflow-hidden', 'cart-sidebar-show');
          
          whitePageModal.classList.remove('active');
          whitePageModal.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; z-index: -1 !important; background: transparent !important;';
          
          if (document.documentElement) {
            document.documentElement.style.overflow = '';
            document.documentElement.style.position = '';
          }
          
          console.log('✅ White page fixed');
        } catch (e) {
          console.error('Error fixing white page:', e);
        }
      }
    }
    
    // Check if there's a stuck modal without proper content
    const stuckModal = document.getElementById('sb-review-modal');
    if (stuckModal) {
      const content = stuckModal.querySelector('.sb-review-content');
      if (!content || !content.querySelector('.sb-review-items')) {
        console.warn('⚠️ Detected broken/stuck modal, auto-removing...');
        window.__sbCloseAllModals();
      }
    }
    
    // Check if body is blocked without any modal
    const hasReviewModal = !!document.getElementById('sb-review-modal');
    const customizerModal = document.getElementById('pc-individual-modal');
    const hasCustomizerModal = customizerModal && customizerModal.classList.contains('active');
    
    // Only fix body overflow if no modal is actually open
    const bodyHasOverflowHidden = document.body.classList.contains('pc-modal-open') || 
                                   document.body.style.overflow === 'hidden';
    
    if (bodyHasOverflowHidden && !hasReviewModal && !hasCustomizerModal) {
      document.body.style.overflow = '';
      document.body.style.pointerEvents = '';
      document.body.classList.remove('pc-modal-open', 'overflow-hidden');
      console.warn('⚠️ Body overflow was stuck without modal, fixed');
    }
    
    // CRITICAL: Check for stuck loading overlays (black or white)
    const stuckOverlays = [
      document.getElementById('sb-saving-overlay'),
      ...document.querySelectorAll('[id*="saving-overlay"]'),
      ...document.querySelectorAll('[class*="saving-overlay"]'),
      ...document.querySelectorAll('[class*="loading-overlay"]')
    ].filter(el => el !== null);
    
    // Check if any of these overlays are visible and shouldn't be
    stuckOverlays.forEach(overlay => {
      const style = window.getComputedStyle(overlay);
      const isVisible = style.display !== 'none' && 
                       style.visibility !== 'hidden' &&
                       parseFloat(style.opacity) > 0;
      
      // If overlay is visible and modal is not open, remove it (black or white)
      if (isVisible && !hasCustomizerModal) {
        console.warn('⚠️ Detected stuck overlay, removing:', overlay.id || overlay.className);
        try {
          overlay.style.display = 'none';
          overlay.style.visibility = 'hidden';
          overlay.style.opacity = '0';
          overlay.style.pointerEvents = 'none';
          overlay.remove();
          
          // Also restore body styles if they're stuck
          document.body.style.overflow = '';
          document.body.style.pointerEvents = '';
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.classList.remove('pc-modal-open', 'overflow-hidden');
        } catch (e) {
          console.error('Error removing stuck overlay:', e);
        }
      }
    });
    
    // CRITICAL: Check for stuck white modal overlay (pc-individual-modal) - causes white freeze
    const stuckWhiteModal = document.getElementById('pc-individual-modal');
    if (stuckWhiteModal) {
      const modalStyle = window.getComputedStyle(stuckWhiteModal);
      const isModalVisible = modalStyle.display !== 'none' && 
                            modalStyle.visibility !== 'hidden' &&
                            parseFloat(modalStyle.opacity) > 0 &&
                            (stuckWhiteModal.classList.contains('active') || 
                             modalStyle.position === 'fixed');
      
      // Also check if body is stuck with fixed position (white freeze indicator)
      const bodyIsStuck = document.body.style.position === 'fixed' || 
                         document.body.classList.contains('pc-modal-open');
      
      // If modal appears stuck OR body is stuck but modal is not active, fix it
      if ((isModalVisible && !hasCustomizerModal) || (bodyIsStuck && !hasCustomizerModal)) {
        console.warn('⚠️ Detected white freeze (stuck modal or body), fixing immediately...');
        try {
          // EMERGENCY FIX: Force hide the modal completely with !important
          stuckWhiteModal.classList.remove('active');
          stuckWhiteModal.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; z-index: -1 !important; background: transparent !important; position: fixed !important;';
          
          // Also hide the panel inside
          const panel = stuckWhiteModal.querySelector('.pc-individual-panel');
          if (panel) {
            panel.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important;';
          }
          
          // EMERGENCY FIX: Restore body styles immediately - CRITICAL for white freeze
          document.body.style.cssText = '';
          document.body.classList.remove('pc-modal-open', 'overflow-hidden', 'cart-sidebar-show');
          
          // Also ensure html is not blocked
          if (document.documentElement) {
            document.documentElement.style.overflow = '';
            document.documentElement.style.position = '';
          }
          
          // Clear any processing flags
          if (window.PerfumeCustomizer && window.PerfumeCustomizer.Individual) {
            if (window.PerfumeCustomizer.Individual.__builderProcessing !== undefined) {
              window.PerfumeCustomizer.Individual.__builderProcessing = false;
            }
          }
          
          console.log('✅ White freeze fixed - modal and body unblocked');
        } catch (e) {
          console.error('❌ Error fixing white freeze:', e);
          // Last resort: try to unblock body at least
          try {
            document.body.style.cssText = '';
            document.body.classList.remove('pc-modal-open', 'overflow-hidden');
          } catch (e2) {
            console.error('❌ Critical: Could not unblock body:', e2);
          }
        }
      }
    }
    
    // Check for invisible overlays blocking clicks
    const overlays = document.querySelectorAll('[style*="position: fixed"][style*="z-index"]');
    overlays.forEach(overlay => {
      const zIndex = parseInt(window.getComputedStyle(overlay).zIndex);
      if (zIndex >= 10000) {
        const rect = overlay.getBoundingClientRect();
        const isFullScreen = rect.width >= window.innerWidth - 10 && rect.height >= window.innerHeight - 10;
        const isVisible = window.getComputedStyle(overlay).display !== 'none' && 
                         window.getComputedStyle(overlay).visibility !== 'hidden' &&
                         window.getComputedStyle(overlay).opacity !== '0';
        if (isFullScreen && isVisible && !overlay.id && !overlay.classList.contains('sb-review-modal')) {
          // Suspicious overlay - hide it
          overlay.style.display = 'none';
          console.warn('⚠️ Removed suspicious blocking overlay:', overlay);
        }
      }
    });
    
    // Ensure Review Your Box buttons are clickable and set up correctly
    const reviewSubmitBtn = $('[data-add-to-cart]', el);
    const reviewResetBtn = $('[data-reset-builder]', el);
    
    if (reviewSubmitBtn) {
      const computedStyle = window.getComputedStyle(reviewSubmitBtn);
      if (computedStyle.pointerEvents === 'none') {
        reviewSubmitBtn.style.pointerEvents = 'auto';
        console.warn('⚠️ Submit button had pointer-events: none, fixed');
      }
      const zIndex = parseInt(computedStyle.zIndex);
      if (isNaN(zIndex) || zIndex < 100) {
        reviewSubmitBtn.style.zIndex = '1000';
        reviewSubmitBtn.style.position = 'relative';
      }
      // Ensure it's not disabled
      if (reviewSubmitBtn.disabled && !reviewSubmitBtn.hasAttribute('data-disabled')) {
        reviewSubmitBtn.disabled = false;
      }
      // Check if button needs to be re-setup (missing setup marker or cursor style)
      if (!reviewSubmitBtn.hasAttribute('data-sb-setup') || 
          window.getComputedStyle(reviewSubmitBtn).pointerEvents === 'none') {
        console.warn('⚠️ Submit button not properly set up, re-setting up...');
        reviewSubmitBtn.removeAttribute('data-sb-setup'); // Allow re-setup
        setupSubmitButton(reviewSubmitBtn);
      }
    } else {
      // Button not found, try to set it up (only once per interval)
      if (!window.__sbSubmitBtnRetry || Date.now() - window.__sbSubmitBtnRetry > 5000) {
        console.warn('⚠️ Submit button not found in auto-fix, attempting setup...');
        setupButtons();
        window.__sbSubmitBtnRetry = Date.now();
      }
    }
    
    if (reviewResetBtn) {
      const computedStyle = window.getComputedStyle(reviewResetBtn);
      if (computedStyle.pointerEvents === 'none') {
        reviewResetBtn.style.pointerEvents = 'auto';
        console.warn('⚠️ Reset button had pointer-events: none, fixed');
      }
      const zIndex = parseInt(computedStyle.zIndex);
      if (isNaN(zIndex) || zIndex < 100) {
        reviewResetBtn.style.zIndex = '1000';
        reviewResetBtn.style.position = 'relative';
      }
      // Ensure it's not disabled
      if (reviewResetBtn.disabled && !reviewResetBtn.hasAttribute('data-disabled')) {
        reviewResetBtn.disabled = false;
      }
      // Check if button needs to be re-setup (missing setup marker or cursor style)
      if (!reviewResetBtn.hasAttribute('data-sb-setup') || 
          window.getComputedStyle(reviewResetBtn).pointerEvents === 'none') {
        console.warn('⚠️ Reset button not properly set up, re-setting up...');
        reviewResetBtn.removeAttribute('data-sb-setup'); // Allow re-setup
        setupResetButton(reviewResetBtn);
      }
    } else {
      // Button not found, try to set it up (only once per interval)
      if (!window.__sbResetBtnRetry || Date.now() - window.__sbResetBtnRetry > 5000) {
        console.warn('⚠️ Reset button not found in auto-fix, attempting setup...');
        setupButtons();
        window.__sbResetBtnRetry = Date.now();
      }
    }
  }, 500); // Check every 500ms for faster white page detection
  // Simple monitoring: Only fix if body is stuck without active modal
  setInterval(() => {
    try {
      const customizerModal = document.getElementById('pc-individual-modal');
      const hasCustomizerModal = customizerModal && customizerModal.classList.contains('active');
      
      // If modal is not open but body is blocked, fix it
      if (!hasCustomizerModal && (document.body.classList.contains('pc-modal-open') || document.body.style.position === 'fixed')) {
        // Hide modal if it exists
        if (customizerModal) {
          customizerModal.classList.remove('active');
          customizerModal.removeAttribute('style');
        }
        
        // Clear body styles
        document.body.classList.remove('pc-modal-open', 'overflow-hidden', 'cart-sidebar-show');
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        
        // Clear html styles
        if (document.documentElement) {
          document.documentElement.style.overflow = '';
          document.documentElement.style.position = '';
        }
      }
    } catch (e) {
      // Silent fail
    }
  }, 1000); // Check every 1 second (less aggressive)

})();



